var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAiReviews(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 671.18 356.55",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #809eb5;\n      }\n\n      .cls-2 {\n        fill: #145b67;\n      }\n\n      .cls-3 {\n        stroke: #929497;\n        stroke-width: .75px;\n      }\n\n      .cls-3, .cls-4, .cls-5, .cls-6 {\n        stroke-miterlimit: 10;\n      }\n\n      .cls-3, .cls-5, .cls-7, .cls-6 {\n        fill: none;\n      }\n\n      .cls-3, .cls-8 {\n        opacity: .64;\n      }\n\n      .cls-9 {\n        clip-path: url(#clippath-11);\n      }\n\n      .cls-10, .cls-11 {\n        fill: #fff;\n      }\n\n      .cls-12 {\n        fill: #82a2bb;\n      }\n\n      .cls-13 {\n        fill: #7692a7;\n      }\n\n      .cls-14 {\n        fill: #7b98ae;\n      }\n\n      .cls-15 {\n        fill: #738ea2;\n      }\n\n      .cls-16 {\n        fill: #f6f6f6;\n      }\n\n      .cls-17, .cls-4 {\n        fill: #383938;\n      }\n\n      .cls-18 {\n        fill: #323234;\n      }\n\n      .cls-19 {\n        fill: #3c8a93;\n      }\n\n      .cls-20 {\n        fill: #718c9f;\n      }\n\n      .cls-21 {\n        fill: #c9a79a;\n      }\n\n      .cls-22 {\n        fill: #e3f3fa;\n      }\n\n      .cls-22, .cls-23 {\n        opacity: .7;\n      }\n\n      .cls-24 {\n        fill: #6f8a9d;\n      }\n\n      .cls-25 {\n        clip-path: url(#clippath-2);\n      }\n\n      .cls-26 {\n        font-size: 20.59px;\n      }\n\n      .cls-26, .cls-27 {\n        fill: #08505e;\n      }\n\n      .cls-26, .cls-11 {\n        font-family: MyriadPro-Bold, 'Myriad Pro';\n        font-weight: 700;\n      }\n\n      .cls-28 {\n        fill: #7b99af;\n      }\n\n      .cls-29 {\n        clip-path: url(#clippath-13);\n      }\n\n      .cls-30 {\n        isolation: isolate;\n      }\n\n      .cls-31 {\n        fill: #045e93;\n      }\n\n      .cls-31, .cls-32, .cls-5, .cls-33 {\n        opacity: .3;\n      }\n\n      .cls-34, .cls-35 {\n        fill: #323232;\n      }\n\n      .cls-36 {\n        fill: #7591a6;\n      }\n\n      .cls-37 {\n        fill: #81a0b7;\n      }\n\n      .cls-38 {\n        fill: #7894ab;\n      }\n\n      .cls-39 {\n        fill: #708b9d;\n      }\n\n      .cls-40 {\n        fill: #0c5c67;\n      }\n\n      .cls-41 {\n        fill: #cccaca;\n        opacity: .62;\n      }\n\n      .cls-42 {\n        fill: #6b8798;\n      }\n\n      .cls-32 {\n        fill: #a9cddb;\n      }\n\n      .cls-43 {\n        fill: #83a2b9;\n      }\n\n      .cls-44 {\n        clip-path: url(#clippath-7);\n      }\n\n      .cls-45 {\n        fill: #313131;\n      }\n\n      .cls-46 {\n        clip-path: url(#clippath-4);\n      }\n\n      .cls-47, .cls-8 {\n        fill: #aeadad;\n      }\n\n      .cls-48 {\n        fill: #085e92;\n        opacity: .2;\n      }\n\n      .cls-49 {\n        fill: #025788;\n        opacity: .1;\n      }\n\n      .cls-50 {\n        opacity: .15;\n      }\n\n      .cls-4 {\n        stroke-width: 4.73px;\n      }\n\n      .cls-4, .cls-5 {\n        stroke: #aeadad;\n        stroke-linecap: round;\n      }\n\n      .cls-51 {\n        opacity: .4;\n      }\n\n      .cls-52 {\n        fill: #9bbedb;\n      }\n\n      .cls-53 {\n        fill: #60aeb7;\n      }\n\n      .cls-54 {\n        fill: #7f9db4;\n      }\n\n      .cls-55 {\n        fill: #6c8698;\n      }\n\n      .cls-56 {\n        fill: #7490a4;\n      }\n\n      .cls-57 {\n        fill: #718da1;\n      }\n\n      .cls-58 {\n        fill: #81a0b9;\n      }\n\n      .cls-59 {\n        clip-path: url(#clippath-9);\n      }\n\n      .cls-60 {\n        clip-path: url(#clippath);\n      }\n\n      .cls-61 {\n        opacity: .49;\n      }\n\n      .cls-62 {\n        fill: #c9c8c7;\n        mix-blend-mode: multiply;\n        opacity: .68;\n      }\n\n      .cls-63 {\n        fill: #1d1d1d;\n      }\n\n      .cls-64 {\n        fill: #202020;\n      }\n\n      .cls-65 {\n        fill: #5fadb7;\n      }\n\n      .cls-66 {\n        fill: #7d9bb1;\n      }\n\n      .cls-6 {\n        stroke: #010101;\n        stroke-width: .25px;\n      }\n\n      .cls-11 {\n        font-size: 8.79px;\n      }\n\n      .cls-67 {\n        clip-path: url(#clippath-3);\n      }\n\n      .cls-68 {\n        fill: #7693a8;\n      }\n\n      .cls-33 {\n        fill: #5aa3af;\n      }\n\n      .cls-69 {\n        fill: #6d8798;\n      }\n\n      .cls-70 {\n        fill: #7d9cb2;\n      }\n\n      .cls-71 {\n        fill: #ffce39;\n      }\n\n      .cls-72 {\n        fill: #e8beab;\n      }\n\n      .cls-73 {\n        fill: #f1f1f1;\n      }\n\n      .cls-74 {\n        fill: #e8bfab;\n      }\n\n      .cls-75 {\n        fill: #6e889b;\n      }\n\n      .cls-76 {\n        clip-path: url(#clippath-5);\n      }\n\n      .cls-77 {\n        fill: #569fab;\n      }\n\n      .cls-78 {\n        fill: #748ea3;\n      }\n\n      .cls-79 {\n        fill: #01272d;\n      }\n\n      .cls-80 {\n        fill: #322212;\n      }\n\n      .cls-81 {\n        fill: #7694a9;\n      }\n\n      .cls-82 {\n        fill: #7490a5;\n      }\n\n      .cls-83 {\n        fill: #7794a9;\n      }\n\n      .cls-84 {\n        fill: #ed6e84;\n      }\n\n      .cls-85 {\n        fill: #809eb6;\n      }\n\n      .cls-86 {\n        fill: #5099a6;\n      }\n\n      .cls-87 {\n        fill: #81a1bb;\n      }\n\n      .cls-23 {\n        fill: #addcea;\n      }\n\n      .cls-88 {\n        fill: #6f889c;\n      }\n\n      .cls-35 {\n        opacity: .76;\n      }\n\n      .cls-89 {\n        fill: #02272e;\n      }\n\n      .cls-90 {\n        fill: #2a292a;\n      }\n\n      .cls-91 {\n        fill: #010101;\n      }\n\n      .cls-92 {\n        fill: #7e9bb2;\n      }\n\n      .cls-93 {\n        fill: #e8bdab;\n      }\n\n      .cls-94 {\n        fill: #7a97ac;\n      }\n    "), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-27",
    points: "373.26 321.57 312.73 321.57 328.73 202.4 357.26 202.4 373.26 321.57"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-2"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "m382.12,80.73c-3.33,3.39-3.28,8.83.11,12.16,3.39,3.33,8.83,3.28,12.16-.11,3.33-3.39,3.28-8.83-.11-12.16-3.39-3.33-8.83-3.28-12.16.11Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-3"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "m395.96,194.3c3.75,3.82,3.69,9.95-.12,13.7-3.82,3.75-9.95,3.69-13.7-.12-3.75-3.82-3.69-9.95.12-13.7,3.82-3.75,9.95-3.69,13.7.12Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-4"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "m199.77,79.93c3.7,3.77,3.65,9.83-.12,13.54-3.77,3.7-9.83,3.65-13.54-.12-3.7-3.77-3.65-9.83.12-13.54,3.77-3.7,9.83-3.65,13.54.12Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-5"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "cls-10",
    cx: 192.65,
    cy: 200.1,
    r: 9.85,
    transform: "translate(-7.66 392.52) rotate(-89.94)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-7"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "cls-7",
    cx: 407.8,
    cy: 123.76,
    r: 17.69
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-9"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "cls-7",
    cx: 210.82,
    cy: 235.41,
    r: 17.69
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-11"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "cls-7",
    cx: 210.82,
    cy: 120.54,
    r: 17.69
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-13"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "cls-7",
    cx: 408.14,
    cy: 232.23,
    r: 17.69
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "cls-30"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Ebene_1"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-61"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-23",
    d: "m308.57,332.17c-57.52,22.18-207.9,47.65-256.04-39.39C-22.25,157.54,89.16,23.04,169.26,42.65c57.51,14.08,92.39,32.32,144.48-3.36,58.93-40.37,236.34-56.88,305.17,16.71,60.64,64.83-4.26,118.12,21.83,168.62,95.81,185.46-171.25,111.12-223.28,92.38-52.02-18.74-80.94,4.4-108.88,15.17Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-33",
    d: "m334.9,336.79c-92.39-1.95-354.73,53.6-333.71-141.48C22.22.23,222.82,137.25,313.73,71.98c90.91-65.28,184.7-114.18,277.68-17.81,92.98,96.37,95.11,108.62,54.98,176.92-40.13,68.3-41.23,138.31-168.98,123.44-127.75-14.87-106.55-16.99-142.51-17.74Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-27",
    points: "373.26 321.57 312.73 321.57 328.73 202.4 357.26 202.4 373.26 321.57"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-60"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-27",
    x: 312.73,
    y: 319.55,
    width: 60.53,
    height: 2.02
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-27",
    x: 312.73,
    y: 317.53,
    width: 60.53,
    height: 2.02
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-27",
    x: 312.73,
    y: 315.51,
    width: 60.53,
    height: 2.02
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-27",
    x: 312.73,
    y: 313.49,
    width: 60.53,
    height: 2.02
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-27",
    x: 312.73,
    y: 311.47,
    width: 60.53,
    height: 2.02
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-27",
    x: 312.73,
    y: 309.45,
    width: 60.53,
    height: 2.02
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-27",
    x: 312.73,
    y: 307.43,
    width: 60.53,
    height: 2.02
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-27",
    x: 312.73,
    y: 305.41,
    width: 60.53,
    height: 2.02
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-27",
    x: 312.73,
    y: 303.39,
    width: 60.53,
    height: 2.02
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-27",
    x: 312.73,
    y: 301.37,
    width: 60.53,
    height: 2.02
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-27",
    x: 312.73,
    y: 299.35,
    width: 60.53,
    height: 2.02
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-27",
    x: 312.73,
    y: 297.33,
    width: 60.53,
    height: 2.02
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-27",
    x: 312.73,
    y: 295.31,
    width: 60.53,
    height: 2.02
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-27",
    x: 312.73,
    y: 293.29,
    width: 60.53,
    height: 2.02
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-27",
    x: 312.73,
    y: 291.27,
    width: 60.53,
    height: 2.02
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-27",
    x: 312.73,
    y: 289.25,
    width: 60.53,
    height: 2.02
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-27",
    x: 312.73,
    y: 287.23,
    width: 60.53,
    height: 2.02
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-27",
    x: 312.73,
    y: 285.21,
    width: 60.53,
    height: 2.02
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-27",
    x: 312.73,
    y: 283.19,
    width: 60.53,
    height: 2.02
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-27",
    x: 312.73,
    y: 281.17,
    width: 60.53,
    height: 2.02
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-27",
    x: 312.73,
    y: 279.15,
    width: 60.53,
    height: 2.02
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-27",
    x: 312.73,
    y: 277.13,
    width: 60.53,
    height: 2.02
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-27",
    x: 312.73,
    y: 275.11,
    width: 60.53,
    height: 2.02
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-27",
    x: 312.73,
    y: 273.09,
    width: 60.53,
    height: 2.02
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-12",
    x: 312.73,
    y: 271.07,
    width: 60.53,
    height: 2.02
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-87",
    x: 312.73,
    y: 269.05,
    width: 60.53,
    height: 2.02
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-43",
    x: 312.73,
    y: 267.04,
    width: 60.53,
    height: 2.02
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-58",
    x: 312.73,
    y: 265.02,
    width: 60.53,
    height: 2.02
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-37",
    x: 312.73,
    y: 263,
    width: 60.53,
    height: 2.02
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-85",
    x: 312.73,
    y: 260.98,
    width: 60.53,
    height: 2.02
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 312.73,
    y: 258.96,
    width: 60.53,
    height: 2.02
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-54",
    x: 312.73,
    y: 256.94,
    width: 60.53,
    height: 2.02
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-92",
    x: 312.73,
    y: 254.92,
    width: 60.53,
    height: 2.02
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-66",
    x: 312.73,
    y: 252.9,
    width: 60.53,
    height: 2.02
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-70",
    x: 312.73,
    y: 250.88,
    width: 60.53,
    height: 2.02
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-28",
    x: 312.73,
    y: 248.86,
    width: 60.53,
    height: 2.02
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-14",
    x: 312.73,
    y: 246.84,
    width: 60.53,
    height: 2.02
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-94",
    x: 312.73,
    y: 244.82,
    width: 60.53,
    height: 2.02
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-38",
    x: 312.73,
    y: 242.8,
    width: 60.53,
    height: 2.02
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-81",
    x: 312.73,
    y: 240.78,
    width: 60.53,
    height: 2.02
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-83",
    x: 312.73,
    y: 238.76,
    width: 60.53,
    height: 2.02
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-68",
    x: 312.73,
    y: 236.74,
    width: 60.53,
    height: 2.02
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-68",
    x: 312.73,
    y: 234.72,
    width: 60.53,
    height: 2.02
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-13",
    x: 312.73,
    y: 232.7,
    width: 60.53,
    height: 2.02
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-36",
    x: 312.73,
    y: 230.68,
    width: 60.53,
    height: 2.02
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-82",
    x: 312.73,
    y: 228.66,
    width: 60.53,
    height: 2.02
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-56",
    x: 312.73,
    y: 226.64,
    width: 60.53,
    height: 2.02
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-78",
    x: 312.73,
    y: 224.62,
    width: 60.53,
    height: 2.02
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-15",
    x: 312.73,
    y: 222.6,
    width: 60.53,
    height: 2.02
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-57",
    x: 312.73,
    y: 220.58,
    width: 60.53,
    height: 2.02
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-20",
    x: 312.73,
    y: 218.56,
    width: 60.53,
    height: 2.02
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-39",
    x: 312.73,
    y: 216.54,
    width: 60.53,
    height: 2.02
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-24",
    x: 312.73,
    y: 214.52,
    width: 60.53,
    height: 2.02
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-88",
    x: 312.73,
    y: 212.5,
    width: 60.53,
    height: 2.02
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-75",
    x: 312.73,
    y: 210.48,
    width: 60.53,
    height: 2.02
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-75",
    x: 312.73,
    y: 208.46,
    width: 60.53,
    height: 2.02
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-69",
    x: 312.73,
    y: 206.44,
    width: 60.53,
    height: 2.02
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-42",
    x: 312.73,
    y: 204.42,
    width: 60.53,
    height: 2.02
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-55",
    x: 312.73,
    y: 202.4,
    width: 60.53,
    height: 2.02
  }))), /*#__PURE__*/React.createElement("path", {
    className: "cls-27",
    d: "m168.15,36.52h349.69c7.12,0,12.89,5.78,12.89,12.89v212.76c0,7.12-5.78,12.89-12.89,12.89H168.15c-7.12,0-12.89-5.78-12.89-12.89V49.41c0-7.11,5.78-12.89,12.89-12.89Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "m517.69,267.2H168c-2.91,0-5.27-2.25-5.27-5.02V59.24c0-2.78,2.36-5.02,5.27-5.02h349.69c2.91,0,5.27,2.25,5.27,5.02v202.93c0,2.78-2.36,5.02-5.27,5.02Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-19",
    x: 162.61,
    y: 44.76,
    width: 360.41,
    height: 14.41
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-22",
    x: 169.81,
    y: 48.82,
    width: 37.32,
    height: 5.33
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-22",
    x: 491.69,
    y: 49.12,
    width: 6.02,
    height: 4.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-22",
    x: 500.02,
    y: 49.12,
    width: 6.02,
    height: 4.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-22",
    x: 508.36,
    y: 49.12,
    width: 6.02,
    height: 4.72
  }))), /*#__PURE__*/React.createElement("rect", {
    className: "cls-27",
    x: 253.49,
    y: 317.35,
    width: 179.02,
    height: 8.45
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-49",
    d: "m317.39,334.03c-67.27-.11-191.23,2.12-175.93-9.17,15.3-11.29,96.05-.24,162.24-4.01,66.19-3.78,126.11-8.12,193.8-2.54,67.69,5.58,49.29,12,19.58,13.82-54.6,3.33-64.29,4.77-95.94,2.94-92.65-5.36-77.57-.98-103.75-1.03Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-50"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-40",
    d: "m403.25,125.48c-2.69-6.23-1.76-11.76-1.53-16.45,1.19-24.2-13.82-44.4-47.77-46.41-23.13-1.37-47.06,2.73-65.83,25.8-22.69,27.89-13.06,69.8,13.53,96.07,10.06,9.94,8.72,18.47,8.72,18.47l-25.12,65.96,102-.55-15.28-32.05,8.04-36.57s22.53,2.57,27.34-6.37c1.31-2.43.14-35.82.14-35.82l8.21-3.23c2.1-.83,2.8-3.31,1.43-5.04-4.56-5.74-11.09-17.35-13.87-23.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-32",
    d: "m353.82,68.09c-2.56-.15-5.06-.23-7.44-.23-23.75,0-41.1,7.65-54.61,24.07-5.02,6.1-8.46,13.13-10.24,20.89-1.7,7.4-1.85,15.31-.46,23.49,1.26,7.44,5.11,19.25,14.66,28.5,16.68,16.18,36.72-25.89,54.69-29.26,35.13-6.59,40.45-16.57,42.17-21.04.8-2.09,6.49-18.73-4.91-33.2-6.64-8.43-19.12-12.35-33.86-13.21Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-65",
    d: "m334.27,133.22h-34.78l-7.79-7.79c-.27-.27-.71-.27-.98,0-.27.27-.27.71,0,.98l8,8c.13.13.31.2.49.2h35.07c.38,0,.69-.31.69-.69s-.31-.69-.69-.69Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-65",
    d: "m381.31,108.22c-3.65,4.01-7.13,7.43-10.63,10.45-5.16,0-10.33,0-15.54,0-.46,0-.83.37-.83.83,0,.46.37.83.83.83h0c5.31,0,10.58,0,15.84,0,.2,0,.39-.07.54-.2,3.63-3.11,7.23-6.64,11.01-10.79.31-.34.28-.87-.06-1.17-.34-.31-.87-.28-1.17.06Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-65",
    d: "m288.34,119.55c-2.34,0-4.24,1.9-4.24,4.24s1.9,4.24,4.24,4.24,4.24-1.9,4.24-4.24-1.9-4.24-4.24-4.24Zm0,6.82c-1.42,0-2.58-1.16-2.58-2.58s1.16-2.58,2.58-2.58,2.58,1.16,2.58,2.58-1.16,2.58-2.58,2.58Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-65",
    d: "m330.15,87.45v-7.37c0-.38-.31-.69-.69-.69s-.69.31-.69.69v7.66c0,.19.08.37.21.5l10.23,9.96v23.26c0,.38.31.69.69.69s.69-.31.69-.69v-23.55c0-.19-.08-.37-.21-.5l-10.23-9.96Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-65",
    d: "m329.25,72.2c-2.34,0-4.24,1.9-4.24,4.24s1.9,4.24,4.24,4.24,4.24-1.9,4.24-4.24-1.9-4.24-4.24-4.24Zm0,6.82c-1.42,0-2.58-1.16-2.58-2.58s1.16-2.58,2.58-2.58,2.58,1.16,2.58,2.58-1.16,2.58-2.58,2.58Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-65",
    d: "m361.3,77.6c-.38,0-.69.31-.69.69v13.45l-7.29,7.29c-.13.13-.2.31-.2.49v17.13c0,.38.31.69.69.69s.69-.31.69-.69v-16.84l7.29-7.29c.13-.13.2-.31.2-.49v-13.74c0-.38-.31-.69-.69-.69Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-65",
    d: "m361.09,70.9c-2.34,0-4.24,1.9-4.24,4.24s1.9,4.24,4.24,4.24,4.24-1.9,4.24-4.24-1.9-4.24-4.24-4.24Zm0,6.82c-1.42,0-2.58-1.16-2.58-2.58s1.16-2.58,2.58-2.58,2.58,1.16,2.58,2.58-1.16,2.58-2.58,2.58Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-65",
    d: "m371.51,73.25c-2.34,0-4.24,1.9-4.24,4.24s1.9,4.24,4.24,4.24,4.24-1.9,4.24-4.24-1.9-4.24-4.24-4.24Zm0,6.82c-1.42,0-2.58-1.16-2.58-2.58s1.16-2.58,2.58-2.58,2.58,1.16,2.58,2.58-1.16,2.58-2.58,2.58Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-65",
    d: "m384.42,102.02c-2.34,0-4.24,1.9-4.24,4.24s1.9,4.24,4.24,4.24,4.24-1.9,4.24-4.24-1.9-4.24-4.24-4.24Zm0,6.82c-1.42,0-2.58-1.16-2.58-2.58s1.16-2.58,2.58-2.58,2.58,1.16,2.58,2.58-1.16,2.58-2.58,2.58Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-65",
    d: "m337.65,119.23h-15.15l-18.63-18.63c-.13-.13-.31-.2-.49-.2h-3.85c-.38,0-.69.31-.69.69s.31.69.69.69h3.57l18.63,18.63c.13.13.31.2.49.2h15.43c.38,0,.69-.31.69-.69s-.31-.69-.69-.69Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-65",
    d: "m296.07,97.02c-2.34,0-4.24,1.9-4.24,4.24s1.9,4.24,4.24,4.24,4.24-1.9,4.24-4.24-1.9-4.24-4.24-4.24Zm0,6.82c-1.42,0-2.58-1.16-2.58-2.58s1.16-2.58,2.58-2.58,2.58,1.16,2.58,2.58-1.16,2.58-2.58,2.58Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-65",
    d: "m288.34,131.68c-2.34,0-4.24,1.9-4.24,4.24s1.9,4.24,4.24,4.24,4.24-1.9,4.24-4.24-1.9-4.24-4.24-4.24Zm0,6.82c-1.42,0-2.58-1.16-2.58-2.58s1.16-2.58,2.58-2.58,2.58,1.16,2.58,2.58-1.16,2.58-2.58,2.58Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-65",
    d: "m305.43,89.04c-2.34,0-4.24,1.9-4.24,4.24s1.9,4.24,4.24,4.24,4.24-1.9,4.24-4.24-1.9-4.24-4.24-4.24Zm0,6.82c-1.42,0-2.58-1.16-2.58-2.58s1.16-2.58,2.58-2.58,2.58,1.16,2.58,2.58-1.16,2.58-2.58,2.58Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-65",
    d: "m288.34,107.4c-2.34,0-4.24,1.9-4.24,4.24s1.9,4.24,4.24,4.24,4.24-1.9,4.24-4.24-1.9-4.24-4.24-4.24Zm0,6.82c-1.42,0-2.58-1.16-2.58-2.58s1.16-2.58,2.58-2.58,2.58,1.16,2.58,2.58-1.16,2.58-2.58,2.58Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-65",
    d: "m346.73,139.6c-.92,0-1.66.74-1.66,1.66v59.66c0,.92.74,1.66,1.66,1.66s1.66-.74,1.66-1.66v-59.66c0-.92-.74-1.66-1.66-1.66Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-65",
    d: "m326.12,179.31c-.28-.26-.72-.26-.98.02-.26.28-.26.72.02.98l20.91,20.04-6.32,24.23c-.1.37.13.75.5.85.06.02.12.02.18.02.31,0,.59-.21.67-.52l6.42-24.62c.06-.24,0-.5-.19-.68l-21.2-20.32Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-65",
    d: "m365.74,183.45l-19.2,16.03-26.33,4.54c-.38.06-.63.42-.57.8.06.34.35.58.68.58.04,0,.08,0,.12-.01l26.51-4.57c.12-.02.23-.07.33-.15l19.34-16.15c.29-.25.33-.68.09-.98-.25-.29-.68-.33-.98-.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-65",
    d: "m365.31,213.25l-18.05-13.66c-.31-.23-.74-.17-.97.13-.23.31-.17.74.13.97l18.05,13.66c.13.09.27.14.42.14.21,0,.42-.09.55-.27.23-.31.17-.74-.13-.97Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-65",
    d: "m328.49,107.71l-4.97-4.42-10.24-10.24c-.13-.13-.31-.2-.49-.2h-3.6c-.38,0-.69.31-.69.69s.31.69.69.69h3.32l10.05,10.05s.02.02.03.03l4.76,4.23v4.12c0,.38.31.69.69.69s.69-.31.69-.69v-4.43c0-.2-.08-.39-.23-.52Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-65",
    d: "m323.04,140.05h-28.35l-2.98-2.98c-.27-.27-.71-.27-.98,0-.27.27-.27.71,0,.98l3.19,3.19c.13.13.31.2.49.2h28.64c.38,0,.69-.31.69-.69s-.31-.69-.69-.69Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-65",
    d: "m323.04,126.14h-7.59l-16.32-16.19c-.13-.13-.31-.2-.49-.2h-6.1c-.38,0-.69.31-.69.69s.31.69.69.69h5.81l16.32,16.19c.13.13.31.2.49.2h7.87c.38,0,.69-.31.69-.69s-.31-.69-.69-.69Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-65",
    d: "m371.63,80.74c-.38,0-.69.31-.69.69v10.98l-10.58,10.58c-.13.13-.2.31-.2.49v12.01c0,.38.31.69.69.69s.69-.31.69-.69v-11.72l10.58-10.58c.13-.13.2-.31.2-.49v-11.27c0-.38-.31-.69-.69-.69Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-65",
    d: "m360.29,151.38c-1,0-1.8.81-1.8,1.8v4.91c0,1,.81,1.8,1.8,1.8s1.8-.81,1.8-1.8v-4.91c0-1-.81-1.8-1.8-1.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-65",
    d: "m332.77,151.38c-1,0-1.8.81-1.8,1.8v4.91c0,1,.81,1.8,1.8,1.8s1.8-.81,1.8-1.8v-4.91c0-1-.81-1.8-1.8-1.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-65",
    d: "m339.75,151.38c-1,0-1.8.81-1.8,1.8v4.91c0,1,.81,1.8,1.8,1.8s1.8-.81,1.8-1.8v-4.91c0-1-.81-1.8-1.8-1.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-65",
    d: "m346.73,151.38c-1,0-1.8.81-1.8,1.8v4.91c0,1,.81,1.8,1.8,1.8s1.8-.81,1.8-1.8v-4.91c0-1-.81-1.8-1.8-1.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-65",
    d: "m353.31,151.38c-1,0-1.8.81-1.8,1.8v4.91c0,1,.81,1.8,1.8,1.8s1.8-.81,1.8-1.8v-4.91c0-1-.81-1.8-1.8-1.8Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-65",
    d: "m360.7,107.85c-1,0-1.8.81-1.8,1.8v4.91c0,1,.81,1.8,1.8,1.8s1.8-.81,1.8-1.8v-4.91c0-1-.81-1.8-1.8-1.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-65",
    d: "m332.77,107.85c-1,0-1.8.81-1.8,1.8v4.91c0,1,.81,1.8,1.8,1.8s1.8-.81,1.8-1.8v-4.91c0-1-.81-1.8-1.8-1.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-65",
    d: "m339.75,107.85c-1,0-1.8.81-1.8,1.8v4.91c0,1,.81,1.8,1.8,1.8s1.8-.81,1.8-1.8v-4.91c0-1-.81-1.8-1.8-1.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-65",
    d: "m346.73,107.85c-1,0-1.8.81-1.8,1.8v4.91c0,1,.81,1.8,1.8,1.8s1.8-.81,1.8-1.8v-4.91c0-1-.81-1.8-1.8-1.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-65",
    d: "m353.72,107.85c-1,0-1.8.81-1.8,1.8v4.91c0,1,.81,1.8,1.8,1.8s1.8-.81,1.8-1.8v-4.91c0-1-.81-1.8-1.8-1.8Z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-65",
    d: "m327.42,118.1h-4.91c-1,0-1.8.81-1.8,1.8s.81,1.8,1.8,1.8h4.91c1,0,1.8-.81,1.8-1.8s-.81-1.8-1.8-1.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-65",
    d: "m327.42,125.08h-4.91c-1,0-1.8.81-1.8,1.8s.81,1.8,1.8,1.8h4.91c1,0,1.8-.81,1.8-1.8s-.81-1.8-1.8-1.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-65",
    d: "m327.42,132.07h-4.91c-1,0-1.8.81-1.8,1.8s.81,1.8,1.8,1.8h4.91c1,0,1.8-.81,1.8-1.8s-.81-1.8-1.8-1.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-65",
    d: "m370.67,132.07h-4.91c-1,0-1.8.81-1.8,1.8s.81,1.8,1.8,1.8h4.91c1,0,1.8-.81,1.8-1.8s-.81-1.8-1.8-1.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-65",
    d: "m327.42,139.05h-4.91c-1,0-1.8.81-1.8,1.8s.81,1.8,1.8,1.8h4.91c1,0,1.8-.81,1.8-1.8s-.81-1.8-1.8-1.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-65",
    d: "m327.42,146.03h-4.91c-1,0-1.8.81-1.8,1.8s.81,1.8,1.8,1.8h4.91c1,0,1.8-.81,1.8-1.8s-.81-1.8-1.8-1.8Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-65",
    d: "m370.55,146.03h-4.91c-1,0-1.8.81-1.8,1.8s.81,1.8,1.8,1.8h4.91c1,0,1.8-.81,1.8-1.8s-.81-1.8-1.8-1.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-65",
    d: "m370.55,118.1h-4.91c-1,0-1.8.81-1.8,1.8s.81,1.8,1.8,1.8h4.91c1,0,1.8-.81,1.8-1.8s-.81-1.8-1.8-1.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-65",
    d: "m370.55,125.08h-4.91c-1,0-1.8.81-1.8,1.8s.81,1.8,1.8,1.8h4.91c1,0,1.8-.81,1.8-1.8s-.81-1.8-1.8-1.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-52",
    d: "m345.28,112.71h-6.17c-1,0-1.8.81-1.8,1.8s.81,1.8,1.8,1.8h6.17c1,0,1.8-.81,1.8-1.8s-.81-1.8-1.8-1.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-65",
    d: "m370.55,139.05h-4.91c-1,0-1.8.81-1.8,1.8s.81,1.8,1.8,1.8h4.91c1,0,1.8-.81,1.8-1.8s-.81-1.8-1.8-1.8Z"
  }))), /*#__PURE__*/React.createElement("circle", {
    className: "cls-65",
    cx: 366.19,
    cy: 184,
    r: 4.64,
    transform: "translate(-39.39 125.24) rotate(-18.43)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-65",
    cx: 325.64,
    cy: 179.81,
    r: 4.64,
    transform: "translate(-32.6 79.63) rotate(-13.28)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-65",
    cx: 364.9,
    cy: 213.81,
    r: 3.63,
    transform: "translate(-57.71 197.48) rotate(-28.15)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-65",
    cx: 346.73,
    cy: 200.93,
    r: 10.45,
    transform: "translate(-21.95 43.87) rotate(-7.02)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-65",
    cx: 340.42,
    cy: 224.76,
    r: 4.64,
    transform: "translate(-67.32 212.54) rotate(-31.72)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-65",
    cx: 320.34,
    cy: 204.71,
    r: 3.82,
    transform: "translate(-32.93 64.27) rotate(-10.9)"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-10",
    x: 330.85,
    y: 118.1,
    width: 31.53,
    height: 31.53,
    rx: 1.62,
    ry: 1.62
  }), /*#__PURE__*/React.createElement("text", {
    className: "cls-26",
    transform: "translate(337.36 141.85)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "KI")))), /*#__PURE__*/React.createElement("rect", {
    className: "cls-6",
    x: 173.69,
    y: 69.71,
    width: 141.89,
    height: 101.01
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-6",
    x: 369.55,
    y: 69.62,
    width: 141.89,
    height: 101.01
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-6",
    x: 369.55,
    y: 182.24,
    width: 141.89,
    height: 84.96
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-6",
    x: 173.69,
    y: 181.88,
    width: 141.89,
    height: 85.32
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    className: "cls-17",
    x1: 416.64,
    y1: 99.44,
    x2: 404.22,
    y2: 99.44
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-47",
    d: "m416.64,100.61h-12.42c-.65,0-1.17-.53-1.17-1.17s.53-1.17,1.17-1.17h12.42c.65,0,1.17.53,1.17,1.17s-.53,1.17-1.17,1.17Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    className: "cls-17",
    x1: 464.99,
    y1: 88.32,
    x2: 404.33,
    y2: 88.32
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-47",
    d: "m464.99,89.5h-60.66c-.65,0-1.17-.53-1.17-1.17s.53-1.17,1.17-1.17h60.66c.65,0,1.17.53,1.17,1.17s-.53,1.17-1.17,1.17Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    className: "cls-17",
    x1: 464.99,
    y1: 91.98,
    x2: 404.33,
    y2: 91.98
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-47",
    d: "m464.99,93.15h-60.66c-.65,0-1.17-.53-1.17-1.17s.53-1.17,1.17-1.17h60.66c.65,0,1.17.53,1.17,1.17s-.53,1.17-1.17,1.17Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    className: "cls-17",
    x1: 464.99,
    y1: 95.63,
    x2: 404.33,
    y2: 95.63
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-47",
    d: "m464.99,96.81h-60.66c-.65,0-1.17-.53-1.17-1.17s.53-1.17,1.17-1.17h60.66c.65,0,1.17.53,1.17,1.17s-.53,1.17-1.17,1.17Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-71",
    points: "445.45 83.21 447.69 84.16 447.48 81.73 449.07 79.89 446.7 79.34 445.45 77.26 444.19 79.34 441.82 79.89 443.41 81.73 443.2 84.16 445.45 83.21"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-71",
    points: "435.7 83.21 437.95 84.16 437.74 81.73 439.33 79.89 436.96 79.34 435.7 77.26 434.45 79.34 432.08 79.89 433.67 81.73 433.46 84.16 435.7 83.21"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-71",
    points: "425.96 83.21 428.2 84.16 427.99 81.73 429.59 79.89 427.22 79.34 425.96 77.26 424.71 79.34 422.33 79.89 423.93 81.73 423.72 84.16 425.96 83.21"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-71",
    points: "416.25 83.19 418.49 84.14 418.28 81.71 419.88 79.87 417.51 79.33 416.25 77.24 414.99 79.33 412.62 79.87 414.22 81.71 414.01 84.14 416.25 83.19"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-41",
    points: "406.48 83.21 408.72 84.16 408.51 81.73 410.11 79.89 407.73 79.34 406.48 77.26 405.22 79.34 402.85 79.89 404.45 81.73 404.24 84.16 406.48 83.21"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "m394.94,80.19c3.63,3.69,3.57,9.63-.12,13.26-3.69,3.63-9.63,3.57-13.26-.12-3.63-3.69-3.57-9.63.12-13.26,3.69-3.63,9.63-3.57,13.26.12Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-84",
    d: "m388.25,87.2c-1.36,0-2.47-1.11-2.47-2.47,0-1.36,1.11-2.47,2.47-2.47s2.47,1.11,2.47,2.47-1.11,2.47-2.47,2.47Zm-3.04,4.7h6.07c.76,0,1.29-.7,1.09-1.42l-.33-1.2c-.14-.59-.36-1.12-.65-1.58-.28-.44-.87-.6-1.32-.34-.53.3-1.15.47-1.82.47s-1.29-.17-1.82-.47c-.45-.25-1.04-.1-1.32.34-.29.46-.52.99-.65,1.58l-.33,1.2c-.2.72.33,1.42,1.09,1.42Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "m394.86,79.52c3.58,3.64,3.52,9.49-.12,13.07-3.64,3.58-9.49,3.52-13.07-.12-3.58-3.64-3.52-9.49.12-13.07,3.64-3.58,9.49-3.52,13.07.12Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "m382.12,80.73c-3.33,3.39-3.28,8.83.11,12.16,3.39,3.33,8.83,3.28,12.16-.11,3.33-3.39,3.28-8.83-.11-12.16-3.39-3.33-8.83-3.28-12.16.11Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-25"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-19",
    d: "m394.36,95.73l-1.32.25c-3.16.6-6.4.6-9.56,0l-1.32-.25.87-3.35c.21-.8.87-1.4,1.69-1.52l.64-.1c1.92-.29,3.88-.29,5.8,0l.64.1c.82.12,1.48.72,1.69,1.52l.87,3.35Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-74",
    d: "m389.81,90.67h0c-.8.8-2.1.8-2.9,0h0l.22-1.82h2.46l.22,1.82Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-62",
    d: "m389.51,88.22c-.34.12-.74.18-1.15.18h0c-.42,0-.81-.07-1.15-.18l-.19,1.54c.39.15,1.76.47,2.72.33l-.23-1.86Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-63",
    d: "m385.18,91.98s0-2.79,3.08-2.79,3.08.86,3.08.86l.57-3.65h-7.73l1,5.58Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-90",
    d: "m388.26,79.96h0c-2.57,0-4.65,1.82-4.65,4.39v3.62l1.58,4.01v-.57l.32-4.19,1.92-2.19c.94-1.07,2.29-1.69,3.71-1.71h.2s0,6.73,0,6.73l1.58-4.08v-1.61c0-2.57-2.08-4.39-4.65-4.39Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-74",
    d: "m388.26,89.61h0c-1.7,0-3.08-1.38-3.08-3.08v-4.82h6.16v4.82c0,1.7-1.38,3.08-3.08,3.08Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "m388.26,79.7h0c-2.57,0-4.65,2.08-4.65,4.65h-1.43l.6,1.23c.51,1.04,1.58,1.68,2.73,1.63h0l1.92-2.19c.94-1.07,2.29-1.69,3.71-1.71h.2s0,6.73,0,6.73l1.58-4.08v-1.61c0-2.57-2.08-4.65-4.65-4.65Z"
  }))))), /*#__PURE__*/React.createElement("line", {
    className: "cls-5",
    x1: 188.32,
    y1: 176.3,
    x2: 297.38,
    y2: 176.3
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-5",
    x1: 392.26,
    y1: 176.43,
    x2: 501.32,
    y2: 176.43
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    className: "cls-17",
    x1: 468.97,
    y1: 203.03,
    x2: 405.38,
    y2: 203.03
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-47",
    d: "m468.97,204.28h-63.6c-.69,0-1.26-.56-1.26-1.26s.56-1.26,1.26-1.26h63.6c.69,0,1.26.56,1.26,1.26s-.56,1.26-1.26,1.26Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    className: "cls-17",
    x1: 439.32,
    y1: 206.86,
    x2: 405.38,
    y2: 206.86
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-47",
    d: "m439.32,208.12h-33.95c-.69,0-1.26-.56-1.26-1.26s.56-1.26,1.26-1.26h33.95c.69,0,1.26.56,1.26,1.26s-.56,1.26-1.26,1.26Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "m396.05,194.99c3.8,3.87,3.75,10.09-.13,13.9-3.87,3.8-10.1,3.75-13.9-.13-3.8-3.87-3.75-10.09.13-13.9,3.87-3.8,10.1-3.75,13.9.13Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-84",
    d: "m389.03,202.34c-1.43,0-2.59-1.16-2.59-2.59s1.16-2.59,2.59-2.59c1.43,0,2.59,1.16,2.59,2.59,0,1.43-1.16,2.59-2.59,2.59Zm-3.18,4.93h6.36c.8,0,1.35-.73,1.14-1.49l-.35-1.26c-.14-.62-.38-1.18-.68-1.66-.29-.46-.91-.62-1.38-.36-.55.31-1.21.49-1.91.49s-1.36-.18-1.91-.49c-.47-.27-1.09-.1-1.38.36-.3.48-.54,1.03-.68,1.66l-.35,1.26c-.21.76.34,1.49,1.14,1.49Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "m395.96,194.3c3.75,3.82,3.69,9.95-.12,13.7-3.82,3.75-9.95,3.69-13.7-.12-3.75-3.82-3.69-9.95.12-13.7,3.82-3.75,9.95-3.69,13.7.12Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-67"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m382.17,211.2l1.49.28c3.56.67,7.21.67,10.77,0l1.49-.28-.98-3.77c-.23-.9-.98-1.57-1.9-1.71l-.72-.11c-2.17-.32-4.37-.32-6.54,0l-.72.11c-.92.14-1.67.81-1.9,1.71l-.98,3.77Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-80",
    d: "m392.46,207.09s0-3.1-3.42-3.1c-3.42,0-3.42.95-3.42.95l-.64-4.05h8.58s-1.11,6.2-1.11,6.2Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-74",
    d: "m387.41,205.73h0c.9.91,2.36.9,3.26,0h0l-.25-2.05h-2.77s-.25,2.05-.25,2.05Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-62",
    d: "m387.75,202.97c.39.13.83.21,1.3.21h0c.47,0,.91-.07,1.3-.21l.21,1.73c-.44.17-1.99.53-3.06.37l.26-2.1Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-74",
    d: "m388.76,195.69h.57c1.73,0,3.13,1.4,3.13,3.13v3.63c0,1.11-.9,2.01-2.01,2.01h-2.82c-1.11,0-2.01-.9-2.01-2.01v-3.63c0-1.73,1.4-3.13,3.13-3.13Z",
    transform: "translate(778.09 400.15) rotate(-180)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-62",
    d: "m391.42,201.66h0c-.27-2.3-.97-4.14-3.38-5.24l-.06-.06,1.54-1.65,3.6,3.88-1.71,3.07Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-62",
    d: "m386.27,201.66c.2,1.12.6,1.84,1.13,2.39-1.06-.58-1.78-1.71-1.78-3v-5.35s.79.53.61,2.45c-.11,1.11-.12,2.01-.06,2.77l.09.74Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "m393.05,207.71l-.59-7.1-.77,1.3-.11-.38c.64-3.32-1.28-5.03-4.52-5.21h0l-.78,2.03c-.19.5-.34,1.01-.45,1.53-.23,1.12-.13,2.28.25,3.36l.9,2.5h0c-1.95-1.28-3.12-3.45-3.12-5.78v-1.33c0-2.85,2.31-5.17,5.17-5.17h0c2.85,0,5.17,2.31,5.17,5.17v1.57c0,2.31-.32,4.61-.96,6.84l-.19.68"
  })))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-71",
    points: "447.39 195.9 449.74 196.9 449.52 194.35 451.19 192.42 448.7 191.85 447.39 189.66 446.07 191.85 443.58 192.42 445.26 194.35 445.04 196.9 447.39 195.9"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-71",
    points: "437.17 195.9 439.52 196.9 439.3 194.35 440.98 192.42 438.49 191.85 437.17 189.66 435.86 191.85 433.37 192.42 435.04 194.35 434.82 196.9 437.17 195.9"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-71",
    points: "426.96 195.9 429.31 196.9 429.09 194.35 430.76 192.42 428.28 191.85 426.96 189.66 425.64 191.85 423.16 192.42 424.83 194.35 424.61 196.9 426.96 195.9"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-41",
    points: "416.75 195.9 419.1 196.9 418.88 194.35 420.55 192.42 418.06 191.85 416.75 189.66 415.43 191.85 412.94 192.42 414.62 194.35 414.4 196.9 416.75 195.9"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-41",
    points: "406.53 195.9 408.88 196.9 408.66 194.35 410.34 192.42 407.85 191.85 406.53 189.66 405.22 191.85 402.73 192.42 404.4 194.35 404.18 196.9 406.53 195.9"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    className: "cls-17",
    x1: 270.67,
    y1: 88.32,
    x2: 207.83,
    y2: 88.32
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-47",
    d: "m270.67,89.56h-62.84c-.68,0-1.24-.56-1.24-1.24s.56-1.24,1.24-1.24h62.84c.68,0,1.24.56,1.24,1.24s-.56,1.24-1.24,1.24Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    className: "cls-17",
    x1: 241.38,
    y1: 92.1,
    x2: 207.83,
    y2: 92.1
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-47",
    d: "m241.38,93.34h-33.55c-.68,0-1.24-.56-1.24-1.24s.56-1.24,1.24-1.24h33.55c.68,0,1.24.56,1.24,1.24s-.56,1.24-1.24,1.24Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "m199.86,80.61c3.76,3.83,3.7,9.98-.12,13.73-3.83,3.76-9.98,3.7-13.74-.12-3.76-3.83-3.7-9.98.12-13.73,3.83-3.76,9.98-3.7,13.74.12Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-84",
    d: "m192.93,87.88c-1.41,0-2.56-1.15-2.56-2.56s1.15-2.56,2.56-2.56,2.56,1.15,2.56,2.56-1.15,2.56-2.56,2.56Zm-3.14,4.87h6.29c.79,0,1.33-.72,1.13-1.47l-.34-1.25c-.14-.61-.37-1.16-.67-1.64-.29-.45-.9-.62-1.37-.35-.55.31-1.19.49-1.89.49s-1.34-.18-1.89-.49c-.46-.26-1.08-.1-1.37.35-.3.47-.53,1.02-.67,1.64l-.34,1.25c-.21.75.34,1.47,1.13,1.47Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "m199.77,79.93c3.7,3.77,3.65,9.83-.12,13.54-3.77,3.7-9.83,3.65-13.54-.12-3.7-3.77-3.65-9.83.12-13.54,3.77-3.7,9.83-3.65,13.54.12Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-46"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m186.15,96.63l1.47.28c3.52.66,7.13.66,10.64,0l1.47-.28-.97-3.73c-.23-.89-.97-1.56-1.88-1.69l-.71-.11c-2.14-.32-4.32-.32-6.46,0l-.71.11c-.91.14-1.65.8-1.88,1.69l-.97,3.73Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-80",
    d: "m196.32,92.56s0-3.06-3.38-3.06-3.38.94-3.38.94l-.63-4.01h8.48s-1.1,6.13-1.1,6.13Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-74",
    d: "m191.33,91.22h0c.89.9,2.34.89,3.22,0h0l-.25-2.02h-2.73s-.25,2.02-.25,2.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-62",
    d: "m191.66,88.5c.38.13.82.2,1.28.2h0c.46,0,.9-.07,1.28-.2l.21,1.71c-.43.17-1.96.53-3.03.36l.25-2.08Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-74",
    d: "m192.66,81.31h.57c1.71,0,3.09,1.39,3.09,3.09v3.59c0,1.1-.89,1.98-1.98,1.98h-2.79c-1.1,0-1.98-.89-1.98-1.98v-3.59c0-1.71,1.39-3.09,3.09-3.09Z",
    transform: "translate(385.88 171.28) rotate(180)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-62",
    d: "m195.28,87.2h0c-.27-2.27-.95-4.1-3.34-5.18l-.06-.06,1.53-1.63,3.56,3.83-1.69,3.03Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-62",
    d: "m190.2,87.2c.19,1.11.6,1.82,1.12,2.36-1.05-.57-1.76-1.69-1.76-2.96v-5.29s.78.53.6,2.42c-.11,1.09-.12,1.99-.06,2.74l.09.73Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "m196.9,93.18l-.58-7.02-.76,1.29-.11-.37c.64-3.29-1.26-4.97-4.47-5.15h0l-.77,2c-.19.49-.34,1-.44,1.51-.23,1.11-.13,2.26.25,3.32l.89,2.47h0c-1.92-1.26-3.08-3.41-3.08-5.71v-1.31c0-2.82,2.29-5.11,5.11-5.11h0c2.82,0,5.11,2.29,5.11,5.11v1.56c0,2.29-.32,4.56-.95,6.76l-.19.67"
  }))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-71",
    points: "251.47 83.29 253.79 84.27 253.57 81.76 255.23 79.85 252.77 79.28 251.47 77.12 250.17 79.28 247.71 79.85 249.36 81.76 249.14 84.27 251.47 83.29"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-71",
    points: "241.38 83.29 243.7 84.27 243.48 81.76 245.13 79.85 242.68 79.28 241.38 77.12 240.07 79.28 237.62 79.85 239.27 81.76 239.05 84.27 241.38 83.29"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-71",
    points: "231.28 83.29 233.61 84.27 233.39 81.76 235.04 79.85 232.58 79.28 231.28 77.12 229.98 79.28 227.52 79.85 229.18 81.76 228.96 84.27 231.28 83.29"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-41",
    points: "221.19 83.29 223.51 84.27 223.3 81.76 224.95 79.85 222.49 79.28 221.19 77.12 219.89 79.28 217.43 79.85 219.09 81.76 218.87 84.27 221.19 83.29"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-41",
    points: "211.1 83.29 213.42 84.27 213.2 81.76 214.86 79.85 212.4 79.28 211.1 77.12 209.8 79.28 207.34 79.85 208.99 81.76 208.78 84.27 211.1 83.29"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-47",
    d: "m271.91,204.43h-63.77c-.71,0-1.28-.57-1.28-1.28s.57-1.28,1.28-1.28h63.77c.71,0,1.28.57,1.28,1.28s-.57,1.28-1.28,1.28Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-47",
    d: "m271.91,208.28h-63.77c-.71,0-1.28-.57-1.28-1.28s.57-1.28,1.28-1.28h63.77c.71,0,1.28.57,1.28,1.28s-.57,1.28-1.28,1.28Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-47",
    d: "m271.91,212.12h-63.77c-.71,0-1.28-.57-1.28-1.28s.57-1.28,1.28-1.28h63.77c.71,0,1.28.57,1.28,1.28s-.57,1.28-1.28,1.28Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-47",
    d: "m256.36,215.96h-48.23c-.71,0-1.28-.57-1.28-1.28s.57-1.28,1.28-1.28h48.23c.71,0,1.28.57,1.28,1.28s-.57,1.28-1.28,1.28Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "m185.58,194.05c-3.81,3.88-3.76,10.12.13,13.94,3.88,3.81,10.12,3.76,13.94-.13,3.81-3.88,3.76-10.12-.13-13.94-3.88-3.81-10.12-3.76-13.94.13Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-84",
    d: "m190.14,199.7c0-1.43,1.16-2.6,2.6-2.6s2.6,1.16,2.6,2.6-1.16,2.6-2.6,2.6-2.6-1.16-2.6-2.6Zm6.93,6.05l-.35-1.27c-.14-.62-.38-1.18-.68-1.66-.29-.46-.92-.63-1.39-.36-.55.31-1.21.5-1.92.5s-1.36-.18-1.92-.5c-.47-.27-1.09-.1-1.39.36-.3.48-.54,1.04-.68,1.66l-.35,1.27c-.21.76.34,1.49,1.14,1.49h6.38c.8,0,1.35-.73,1.14-1.49Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    className: "cls-10",
    cx: 192.65,
    cy: 200.1,
    r: 9.85,
    transform: "translate(-7.66 392.52) rotate(-89.94)"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-76"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-77",
    d: "m200.35,210.01l-1.67.31c-3.99.75-8.08.75-12.07,0l-1.67-.31,1.1-4.23c.26-1.01,1.1-1.76,2.13-1.92l.81-.12c2.43-.36,4.9-.36,7.33,0l.81.12c1.03.15,1.87.91,2.13,1.92l1.1,4.23Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-74",
    d: "m194.6,203.7l-.1.08c-1.13.86-2.71.83-3.8-.08h0v-1.95h3.9v1.95Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-64",
    d: "m196.96,197.66c0,.61-.62,1.26-.81.2-.16-.89-1.62-3.19-2.17-2.19-.78,1.42-2.31-.37-3.49-.37-2.51,0,.84,2.58-2.17,2.96-.23.03-.51-.11-.51-.34.01-2.73,2.34-4.59,4.83-4.59,2.62,0,4.32,1.71,4.32,4.33Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-21",
    cx: 192.56,
    cy: 198.61,
    r: 4.4,
    transform: "translate(-44.97 340.39) rotate(-76.72)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-74",
    d: "m196.96,198.22c0,2.43-1.97,4.4-4.4,4.4s-4.4-1.97-4.4-4.4,1.97-4.4,4.4-4.4,4.4,1.97,4.4,4.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "m192.65,192.51c-3.24,0-5.37,2.7-4.88,5.46.75,1.04-.9-2.47,2.03-2.47,1.32,0,3.94,1.58,4.18,1.12,1.11-2.11,1.98-1.35,2.42.81.2.99.85,2.04,1.12.53.5-2.77-1.64-5.46-4.88-5.46Z"
  }))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-71",
    points: "212.27 196.17 209.91 197.17 210.13 194.62 208.45 192.68 210.95 192.11 212.27 189.91 213.59 192.11 216.08 192.68 214.4 194.62 214.63 197.17 212.27 196.17"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-71",
    points: "222.51 196.17 220.15 197.17 220.37 194.62 218.7 192.68 221.19 192.11 222.51 189.91 223.83 192.11 226.32 192.68 224.65 194.62 224.87 197.17 222.51 196.17"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-71",
    points: "232.75 196.17 230.39 197.17 230.61 194.62 228.94 192.68 231.43 192.11 232.75 189.91 234.07 192.11 236.56 192.68 234.89 194.62 235.11 197.17 232.75 196.17"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-71",
    points: "242.99 196.17 240.63 197.17 240.86 194.62 239.18 192.68 241.67 192.11 242.99 189.91 244.31 192.11 246.81 192.68 245.13 194.62 245.35 197.17 242.99 196.17"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-71",
    points: "253.23 196.17 250.88 197.17 251.1 194.62 249.42 192.68 251.91 192.11 253.23 189.91 254.55 192.11 257.05 192.68 255.37 194.62 255.59 197.17 253.23 196.17"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    className: "cls-17",
    x1: 500.79,
    y1: 121.21,
    x2: 429.74,
    y2: 121.21
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-47",
    d: "m500.79,123.16h-71.05c-1.07,0-1.94-.87-1.94-1.94s.87-1.94,1.94-1.94h71.05c1.07,0,1.94.87,1.94,1.94s-.87,1.94-1.94,1.94Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    className: "cls-17",
    x1: 500.79,
    y1: 128.73,
    x2: 429.74,
    y2: 128.73
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-47",
    d: "m500.79,130.67h-71.05c-1.07,0-1.94-.87-1.94-1.94s.87-1.94,1.94-1.94h71.05c1.07,0,1.94.87,1.94,1.94s-.87,1.94-1.94,1.94Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    className: "cls-17",
    x1: 500.79,
    y1: 136.24,
    x2: 429.74,
    y2: 136.24
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-47",
    d: "m500.79,138.18h-71.05c-1.07,0-1.94-.87-1.94-1.94s.87-1.94,1.94-1.94h71.05c1.07,0,1.94.87,1.94,1.94s-.87,1.94-1.94,1.94Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    className: "cls-17",
    x1: 500.79,
    y1: 143.75,
    x2: 429.74,
    y2: 143.75
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-47",
    d: "m500.79,145.69h-71.05c-1.07,0-1.94-.87-1.94-1.94s.87-1.94,1.94-1.94h71.05c1.07,0,1.94.87,1.94,1.94s-.87,1.94-1.94,1.94Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    className: "cls-17",
    x1: 500.79,
    y1: 151.38,
    x2: 429.74,
    y2: 151.38
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-47",
    d: "m500.79,153.32h-71.05c-1.07,0-1.94-.87-1.94-1.94s.87-1.94,1.94-1.94h71.05c1.07,0,1.94.87,1.94,1.94s-.87,1.94-1.94,1.94Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    className: "cls-17",
    x1: 450.48,
    y1: 159.01,
    x2: 429.74,
    y2: 159.01
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-47",
    d: "m450.48,160.95h-20.75c-1.07,0-1.94-.87-1.94-1.94s.87-1.94,1.94-1.94h20.75c1.07,0,1.94.87,1.94,1.94s-.87,1.94-1.94,1.94Z"
  }))), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "m380.24,129.06c0,.11.07.2.18.23.02,0,.04,0,.06,0,.09,0,.17-.05.21-.12h0c.71-1.29,2.06-2.09,3.52-2.09h.45v1.34c0,.1.06.18.14.22.09.04.19.02.26-.05l2.68-2.61s.07-.11.07-.17c0-.06-.03-.13-.07-.17l-2.68-2.61c-.07-.07-.17-.09-.26-.05-.09.04-.14.12-.14.22v1.34c-2.45.04-4.42,2.04-4.42,4.5Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "m418.55,115.8c6.14,6.25,6.05,16.3-.2,22.44-6.25,6.14-16.3,6.05-22.45-.2-6.14-6.25-6.05-16.3.2-22.44,6.25-6.14,16.3-6.05,22.45.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "m418.39,114.78c6.05,6.16,5.97,16.07-.2,22.12-6.16,6.05-16.07,5.96-22.12-.2-6.05-6.16-5.97-16.07.2-22.12,6.16-6.05,16.07-5.96,22.12.2Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-44"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-40",
    d: "m415.87,124.61c-.45-1.03-.31-1.95-.27-2.73.17-4.02-2.35-7.35-7.99-7.64-3.84-.2-7.81.51-10.9,4.37-3.73,4.66-2.08,11.61,2.37,15.93,1.68,1.64,1.47,3.06,1.47,3.06l-4.09,10.98,16.93-.22-2.58-5.3,1.29-6.08s3.74.4,4.53-1.09c.21-.41-.02-5.95-.02-5.95l1.36-.55c.35-.14.46-.55.23-.84-.76-.95-1.86-2.87-2.33-3.93Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-32",
    d: "m407.61,115.03c-.43-.02-.84-.03-1.23-.03-3.94.03-6.81,1.32-9.04,4.07-.83,1.02-1.39,2.19-1.67,3.48-.27,1.23-.29,2.54-.05,3.9.22,1.23.87,3.19,2.47,4.71,2.79,2.66,6.06-4.35,9.04-4.93,5.82-1.14,6.69-2.8,6.97-3.55.13-.35,1.05-3.12-.86-5.51-1.11-1.39-3.19-2.03-5.64-2.15Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-65",
    d: "m397.19,126.83c-.31.17-.42.55-.25.86s.55.42.86.25.42-.55.25-.86-.55-.42-.86-.25Zm.49.89c-.19.1-.42.03-.52-.15s-.03-.42.15-.52.42-.03.52.15.03.42-.15.52Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-65",
    d: "m398.06,128.41c-.31.17-.42.55-.25.86s.55.42.86.25.42-.55.25-.86-.55-.42-.86-.25Zm.49.89c-.19.1-.42.03-.52-.15s-.03-.42.15-.52.42-.03.52.15.03.42-.15.52Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-65",
    d: "m396.32,125.24c-.31.17-.42.55-.25.86s.55.42.86.25.42-.55.25-.86-.55-.42-.86-.25Zm.49.89c-.19.1-.42.03-.52-.15s-.03-.42.15-.52.42-.03.52.15.03.42-.15.52Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-65",
    d: "m404.75,125.01l-5.01,2.74-1.68-.4c-.06-.01-.12.02-.14.08-.02.06.01.11.07.13l1.72.42s.06,0,.09-.01l5.05-2.77c.06-.03.08-.1.05-.15s-.09-.07-.15-.04Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-65",
    d: "m400.86,119.36l-.53-.96c-.03-.05-.09-.07-.14-.04s-.07.09-.04.14l.55,1s.04.04.06.05l2.05.57,1.67,3.04c.03.05.09.07.14.04s.07-.09.04-.14l-1.69-3.08s-.04-.04-.06-.05l-2.05-.57Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-65",
    d: "m399.65,117.43c-.31.17-.42.55-.25.86s.55.42.86.25.42-.55.25-.86-.55-.42-.86-.25Zm.49.89c-.19.1-.42.03-.52-.15s-.03-.42.15-.52.42-.03.52.15.03.42-.15.52Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-65",
    d: "m403.41,116.58c-.05.03-.07.09-.04.14l.96,1.76-.43,1.48s0,.05,0,.08l1.23,2.24c.03.05.09.07.14.04s.07-.09.04-.14l-1.21-2.2.43-1.48s0-.05,0-.08l-.98-1.8c-.03-.05-.09-.07-.14-.04Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-65",
    d: "m402.91,115.72c-.31.17-.42.55-.25.86s.55.42.86.25.42-.55.25-.86-.55-.42-.86-.25Zm.49.89c-.19.1-.42.03-.52-.15s-.03-.42.15-.52.42-.03.52.15.03.42-.15.52Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-65",
    d: "m405.77,116.08c-.34.09-.53.44-.44.78s.44.53.78.44.53-.44.44-.78-.44-.53-.78-.44Zm.28.98c-.2.06-.42-.06-.47-.27s.06-.42.27-.47.42.06.47.27-.06.42-.27.47Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-65",
    d: "m403.62,123.25l-1.98,1.08-3.77-1.1s-.05,0-.08,0l-.5.28c-.05.03-.07.09-.04.14s.09.07.14.04l.47-.26,3.77,1.1s.05,0,.08,0l2.02-1.11c.05-.03.07-.09.04-.14s-.09-.07-.14-.04Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-65",
    d: "m396.59,123.32c-.31.17-.42.55-.25.86s.55.42.86.25.42-.55.25-.86-.55-.42-.86-.25Zm.49.89c-.19.1-.42.03-.52-.15s-.03-.42.15-.52.42-.03.52.15.03.42-.15.52Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-65",
    d: "m398.77,121.55c-.31.17-.42.55-.25.86s.55.42.86.25.42-.55.25-.86-.55-.42-.86-.25Zm.49.89c-.19.1-.42.03-.52-.15s-.03-.42.15-.52.42-.03.52.15.03.42-.15.52Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-65",
    d: "m403.38,122.32l-1.04-.22-2.22-.61s-.06,0-.08.01l-.51.28c-.05.03-.07.1-.05.15s.1.07.15.04l.47-.26,2.18.6s0,0,0,0l.99.21.31.56c.03.05.1.07.15.04s.07-.1.05-.15l-.33-.61s-.04-.05-.07-.05Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-65",
    d: "m406.14,125.41l-6.28,3.44-.87-.03c-.08,0-.18.05-.22.12-.04.07,0,.13.07.13l.93.03s.08-.01.12-.03l6.34-3.47c.08-.05.13-.12.1-.17s-.12-.05-.2,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-65",
    d: "m404.17,124.37l-1.45.79-4.32-.5s-.07,0-.11.02l-1.16.64c-.07.04-.11.11-.08.17s.11.06.18.02l1.11-.61,4.32.5s.07,0,.11-.02l1.5-.82c.07-.04.11-.11.08-.17s-.11-.06-.18-.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-65",
    d: "m412.01,119.37c.17.31.55.42.86.25s.42-.55.25-.86-.55-.42-.86-.25-.42.55-.25.86Zm.22-.12c-.1-.19-.03-.42.15-.52s.42-.03.52.15.03.42-.15.52-.42.03-.52-.15Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-65",
    d: "m412.88,120.95c.17.31.55.42.86.25s.42-.55.25-.86-.55-.42-.86-.25-.42.55-.25.86Zm.22-.12c-.1-.19-.03-.42.15-.52s.42-.03.52.15.03.42-.15.52-.42.03-.52-.15Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-65",
    d: "m411.14,117.78c.17.31.55.42.86.25s.42-.55.25-.86-.55-.42-.86-.25-.42.55-.25.86Zm.22-.12c-.1-.19-.03-.42.15-.52s.42-.03.52.15.03.42-.15.52-.42.03-.52-.15Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-65",
    d: "m406.66,123.9l5.01-2.74.56-1.63c.02-.06.08-.09.14-.08.06.01.09.07.07.13l-.58,1.68s-.03.05-.06.07l-5.05,2.77c-.06.03-.12.01-.15-.04s0-.12.05-.15Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-65",
    d: "m406.25,125.29l6.28-3.44.45-.75c.04-.07.14-.12.22-.12.08,0,.11.06.07.13l-.48.8s-.05.06-.09.09l-6.34,3.47c-.08.05-.18.04-.2,0s.02-.13.1-.17Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-65",
    d: "m405.79,122l1.98-1.08,1.1-3.77s.03-.05.05-.06l.5-.28c.05-.03.11,0,.14.04s0,.11-.04.14l-.47.26-1.1,3.77s-.03.05-.05.06l-2.02,1.11c-.05.03-.11,0-.14-.04s0-.11.04-.14Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-65",
    d: "m409.39,116.97c.17.31.55.42.86.25s.42-.55.25-.86-.55-.42-.86-.25-.42.55-.25.86Zm.22-.12c-.1-.19-.03-.42.15-.52s.42-.03.52.15.03.42-.15.52-.42.03-.52-.15Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-65",
    d: "m406.43,123.07l1.45-.79,1.9-3.91s.04-.06.08-.08l1.16-.64c.07-.04.16-.03.18.02s0,.13-.08.17l-1.11.61-1.9,3.91s-.04.06-.08.08l-1.5.82c-.07.04-.16.03-.18-.02s0-.13.08-.17Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-65",
    d: "m406.09,117.15c-.05.02-.09.07-.07.13l.44,1.58-1.09,1.95s-.02.05,0,.08l.49,1.72c.02.05.07.09.13.07s.09-.07.07-.13l-.47-1.68,1.09-1.95s.02-.05,0-.08l-.46-1.62c-.02-.05-.07-.09-.13-.07Z"
  }), /*#__PURE__*/React.createElement("text", {
    className: "cls-11",
    transform: "translate(404.36 132.54) rotate(-.44)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "KI")))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 304.41,
    y1: 233.03,
    x2: 232.52,
    y2: 233.03
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 304.41,
    y1: 240.63,
    x2: 232.52,
    y2: 240.63
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 266.77,
    y1: 247.62,
    x2: 232.73,
    y2: 247.62
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "m182.99,240.78c0,.11.07.2.18.23.02,0,.04,0,.06,0,.09,0,.17-.05.21-.12h0c.71-1.29,2.06-2.09,3.52-2.09h.45v1.34c0,.1.06.18.14.22.09.04.19.02.26-.05l2.68-2.61s.07-.11.07-.17c0-.06-.03-.13-.07-.17l-2.68-2.61c-.07-.07-.17-.09-.26-.05-.09.04-.14.12-.14.22v1.34c-2.45.04-4.42,2.04-4.42,4.5Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "m221.57,227.45c6.14,6.25,6.05,16.3-.2,22.44-6.25,6.14-16.3,6.05-22.45-.2-6.14-6.25-6.05-16.3.2-22.44,6.25-6.14,16.3-6.05,22.45.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "m221.4,226.42c6.05,6.16,5.97,16.07-.2,22.12-6.16,6.05-16.07,5.96-22.12-.2-6.05-6.16-5.97-16.07.2-22.12,6.16-6.05,16.07-5.96,22.12.2Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-59"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-40",
    d: "m218.88,236.26c-.45-1.03-.31-1.95-.27-2.73.17-4.02-2.35-7.35-7.99-7.64-3.84-.2-7.81.51-10.9,4.37-3.73,4.66-2.08,11.61,2.37,15.93,1.68,1.64,1.47,3.06,1.47,3.06l-4.09,10.98,16.93-.22-2.58-5.3,1.29-6.08s3.74.4,4.53-1.09c.21-.41-.02-5.95-.02-5.95l1.36-.55c.35-.14.46-.55.23-.84-.76-.95-1.86-2.87-2.33-3.93Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-32",
    d: "m210.63,226.68c-.43-.02-.84-.03-1.23-.03-3.94.03-6.81,1.32-9.04,4.07-.83,1.02-1.39,2.19-1.67,3.48-.27,1.23-.29,2.54-.05,3.9.22,1.23.87,3.19,2.47,4.71,2.79,2.66,6.06-4.35,9.04-4.93,5.82-1.14,6.69-2.8,6.97-3.55.13-.35,1.05-3.12-.86-5.51-1.11-1.39-3.19-2.03-5.64-2.15Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-65",
    d: "m200.2,238.47c-.31.17-.42.55-.25.86s.55.42.86.25.42-.55.25-.86-.55-.42-.86-.25Zm.49.89c-.19.1-.42.03-.52-.15s-.03-.42.15-.52.42-.03.52.15.03.42-.15.52Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-65",
    d: "m201.07,240.06c-.31.17-.42.55-.25.86s.55.42.86.25.42-.55.25-.86-.55-.42-.86-.25Zm.49.89c-.19.1-.42.03-.52-.15s-.03-.42.15-.52.42-.03.52.15.03.42-.15.52Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-65",
    d: "m199.33,236.89c-.31.17-.42.55-.25.86s.55.42.86.25.42-.55.25-.86-.55-.42-.86-.25Zm.49.89c-.19.1-.42.03-.52-.15s-.03-.42.15-.52.42-.03.52.15.03.42-.15.52Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-65",
    d: "m207.77,236.65l-5.01,2.74-1.68-.4c-.06-.01-.12.02-.14.08-.02.06.01.11.07.13l1.72.42s.06,0,.09-.01l5.05-2.77c.06-.03.08-.1.05-.15s-.09-.07-.15-.04Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-65",
    d: "m203.87,231.01l-.53-.96c-.03-.05-.09-.07-.14-.04s-.07.09-.04.14l.55,1s.04.04.06.05l2.05.57,1.67,3.04c.03.05.09.07.14.04s.07-.09.04-.14l-1.69-3.08s-.04-.04-.06-.05l-2.05-.57Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-65",
    d: "m202.66,229.08c-.31.17-.42.55-.25.86s.55.42.86.25.42-.55.25-.86-.55-.42-.86-.25Zm.49.89c-.19.1-.42.03-.52-.15s-.03-.42.15-.52.42-.03.52.15.03.42-.15.52Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-65",
    d: "m206.43,228.23c-.05.03-.07.09-.04.14l.96,1.76-.43,1.48s0,.05,0,.08l1.23,2.24c.03.05.09.07.14.04s.07-.09.04-.14l-1.21-2.2.43-1.48s0-.05,0-.08l-.98-1.8c-.03-.05-.09-.07-.14-.04Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-65",
    d: "m205.92,227.37c-.31.17-.42.55-.25.86s.55.42.86.25.42-.55.25-.86-.55-.42-.86-.25Zm.49.89c-.19.1-.42.03-.52-.15s-.03-.42.15-.52.42-.03.52.15.03.42-.15.52Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-65",
    d: "m208.79,227.73c-.34.09-.53.44-.44.78s.44.53.78.44.53-.44.44-.78-.44-.53-.78-.44Zm.28.98c-.2.06-.42-.06-.47-.27s.06-.42.27-.47.42.06.47.27-.06.42-.27.47Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-65",
    d: "m206.63,234.9l-1.98,1.08-3.77-1.1s-.05,0-.08,0l-.5.28c-.05.03-.07.09-.04.14s.09.07.14.04l.47-.26,3.77,1.1s.05,0,.08,0l2.02-1.11c.05-.03.07-.09.04-.14s-.09-.07-.14-.04Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-65",
    d: "m199.6,234.97c-.31.17-.42.55-.25.86s.55.42.86.25.42-.55.25-.86-.55-.42-.86-.25Zm.49.89c-.19.1-.42.03-.52-.15s-.03-.42.15-.52.42-.03.52.15.03.42-.15.52Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-65",
    d: "m201.78,233.2c-.31.17-.42.55-.25.86s.55.42.86.25.42-.55.25-.86-.55-.42-.86-.25Zm.49.89c-.19.1-.42.03-.52-.15s-.03-.42.15-.52.42-.03.52.15.03.42-.15.52Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-65",
    d: "m206.4,233.97l-1.04-.22-2.22-.61s-.06,0-.08.01l-.51.28c-.05.03-.07.1-.05.15s.1.07.15.04l.47-.26,2.18.6s0,0,0,0l.99.21.31.56c.03.05.1.07.15.04s.07-.1.05-.15l-.33-.61s-.04-.05-.07-.05Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-65",
    d: "m209.16,237.06l-6.28,3.44-.87-.03c-.08,0-.18.05-.22.12-.04.07,0,.13.07.13l.93.03s.08-.01.12-.03l6.34-3.47c.08-.05.13-.12.1-.17s-.12-.05-.2,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-65",
    d: "m207.19,236.02l-1.45.79-4.32-.5s-.07,0-.11.02l-1.16.64c-.07.04-.11.11-.08.17s.11.06.18.02l1.11-.61,4.32.5s.07,0,.11-.02l1.5-.82c.07-.04.11-.11.08-.17s-.11-.06-.18-.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-65",
    d: "m215.03,231.02c.17.31.55.42.86.25s.42-.55.25-.86-.55-.42-.86-.25-.42.55-.25.86Zm.22-.12c-.1-.19-.03-.42.15-.52s.42-.03.52.15.03.42-.15.52-.42.03-.52-.15Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-65",
    d: "m215.9,232.6c.17.31.55.42.86.25s.42-.55.25-.86-.55-.42-.86-.25-.42.55-.25.86Zm.22-.12c-.1-.19-.03-.42.15-.52s.42-.03.52.15.03.42-.15.52-.42.03-.52-.15Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-65",
    d: "m214.16,229.43c.17.31.55.42.86.25s.42-.55.25-.86-.55-.42-.86-.25-.42.55-.25.86Zm.22-.12c-.1-.19-.03-.42.15-.52s.42-.03.52.15.03.42-.15.52-.42.03-.52-.15Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-65",
    d: "m209.67,235.55l5.01-2.74.56-1.63c.02-.06.08-.09.14-.08.06.01.09.07.07.13l-.58,1.68s-.03.05-.06.07l-5.05,2.77c-.06.03-.12.01-.15-.04s0-.12.05-.15Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-65",
    d: "m209.26,236.94l6.28-3.44.45-.75c.04-.07.14-.12.22-.12.08,0,.11.06.07.13l-.48.8s-.05.06-.09.09l-6.34,3.47c-.08.05-.18.04-.2,0s.02-.13.1-.17Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-65",
    d: "m208.81,233.65l1.98-1.08,1.1-3.77s.03-.05.05-.06l.5-.28c.05-.03.11,0,.14.04s0,.11-.04.14l-.47.26-1.1,3.77s-.03.05-.05.06l-2.02,1.11c-.05.03-.11,0-.14-.04s0-.11.04-.14Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-65",
    d: "m212.4,228.62c.17.31.55.42.86.25s.42-.55.25-.86-.55-.42-.86-.25-.42.55-.25.86Zm.22-.12c-.1-.19-.03-.42.15-.52s.42-.03.52.15.03.42-.15.52-.42.03-.52-.15Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-65",
    d: "m209.45,234.72l1.45-.79,1.9-3.91s.04-.06.08-.08l1.16-.64c.07-.04.16-.03.18.02s0,.13-.08.17l-1.11.61-1.9,3.91s-.04.06-.08.08l-1.5.82c-.07.04-.16.03-.18-.02s0-.13.08-.17Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-65",
    d: "m209.11,228.8c-.05.02-.09.07-.07.13l.44,1.58-1.09,1.95s-.02.05,0,.08l.49,1.72c.02.05.07.09.13.07s.09-.07.07-.13l-.47-1.68,1.09-1.95s.02-.05,0-.08l-.46-1.62c-.02-.05-.07-.09-.13-.07Z"
  }), /*#__PURE__*/React.createElement("text", {
    className: "cls-11",
    transform: "translate(207.38 244.19) rotate(-.44)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "KI")))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 303.69,
    y1: 116.91,
    x2: 232.55,
    y2: 116.91
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 303.69,
    y1: 124.43,
    x2: 232.55,
    y2: 124.43
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 303.69,
    y1: 131.95,
    x2: 232.55,
    y2: 131.95
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 303.69,
    y1: 139.47,
    x2: 232.55,
    y2: 139.47
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 283.86,
    y1: 147.11,
    x2: 232.55,
    y2: 147.11
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "m183.66,126.39c0,.11.07.2.18.23.02,0,.04,0,.06,0,.09,0,.17-.05.21-.12h0c.71-1.29,2.06-2.09,3.52-2.09h.45v1.34c0,.1.06.18.14.22.09.04.19.02.26-.05l2.68-2.61s.07-.11.07-.17-.03-.13-.07-.17l-2.68-2.61c-.07-.07-.17-.09-.26-.05-.09.04-.14.12-.14.22v1.34c-2.45.04-4.42,2.04-4.42,4.5Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "m221.57,112.59c6.14,6.25,6.05,16.3-.2,22.44-6.25,6.14-16.3,6.05-22.45-.2-6.14-6.25-6.05-16.3.2-22.44,6.25-6.14,16.3-6.05,22.45.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "m221.4,111.56c6.05,6.16,5.97,16.07-.2,22.12-6.16,6.05-16.07,5.96-22.12-.2-6.05-6.16-5.97-16.07.2-22.12,6.16-6.05,16.07-5.96,22.12.2Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-9"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-40",
    d: "m218.88,121.4c-.45-1.03-.31-1.95-.27-2.73.17-4.02-2.35-7.35-7.99-7.64-3.84-.2-7.81.51-10.9,4.37-3.73,4.66-2.08,11.61,2.37,15.93,1.68,1.64,1.47,3.06,1.47,3.06l-4.09,10.98,16.93-.22-2.58-5.3,1.29-6.08s3.74.4,4.53-1.09c.21-.41-.02-5.95-.02-5.95l1.36-.55c.35-.14.46-.55.23-.84-.76-.95-1.86-2.87-2.33-3.93Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-32",
    d: "m210.63,111.82c-.43-.02-.84-.03-1.23-.03-3.94.03-6.81,1.32-9.04,4.07-.83,1.02-1.39,2.19-1.67,3.48-.27,1.23-.29,2.54-.05,3.9.22,1.23.87,3.19,2.47,4.71,2.79,2.66,6.06-4.35,9.04-4.93,5.82-1.14,6.69-2.8,6.97-3.55.13-.35,1.05-3.12-.86-5.51-1.11-1.39-3.19-2.03-5.64-2.15Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-65",
    d: "m200.2,123.61c-.31.17-.42.55-.25.86s.55.42.86.25.42-.55.25-.86-.55-.42-.86-.25Zm.49.89c-.19.1-.42.03-.52-.15s-.03-.42.15-.52.42-.03.52.15.03.42-.15.52Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-65",
    d: "m201.07,125.19c-.31.17-.42.55-.25.86s.55.42.86.25.42-.55.25-.86-.55-.42-.86-.25Zm.49.89c-.19.1-.42.03-.52-.15s-.03-.42.15-.52.42-.03.52.15.03.42-.15.52Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-65",
    d: "m199.33,122.02c-.31.17-.42.55-.25.86s.55.42.86.25.42-.55.25-.86-.55-.42-.86-.25Zm.49.89c-.19.1-.42.03-.52-.15s-.03-.42.15-.52.42-.03.52.15.03.42-.15.52Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-65",
    d: "m207.77,121.79l-5.01,2.74-1.68-.4c-.06-.01-.12.02-.14.08-.02.06.01.11.07.13l1.72.42s.06,0,.09-.01l5.05-2.77c.06-.03.08-.1.05-.15s-.09-.07-.15-.04Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-65",
    d: "m203.87,116.14l-.53-.96c-.03-.05-.09-.07-.14-.04s-.07.09-.04.14l.55,1s.04.04.06.05l2.05.57,1.67,3.04c.03.05.09.07.14.04s.07-.09.04-.14l-1.69-3.08s-.04-.04-.06-.05l-2.05-.57Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-65",
    d: "m202.66,114.21c-.31.17-.42.55-.25.86s.55.42.86.25.42-.55.25-.86-.55-.42-.86-.25Zm.49.89c-.19.1-.42.03-.52-.15s-.03-.42.15-.52.42-.03.52.15.03.42-.15.52Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-65",
    d: "m206.43,113.36c-.05.03-.07.09-.04.14l.96,1.76-.43,1.48s0,.05,0,.08l1.23,2.24c.03.05.09.07.14.04s.07-.09.04-.14l-1.21-2.2.43-1.48s0-.05,0-.08l-.98-1.8c-.03-.05-.09-.07-.14-.04Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-65",
    d: "m205.92,112.5c-.31.17-.42.55-.25.86s.55.42.86.25.42-.55.25-.86-.55-.42-.86-.25Zm.49.89c-.19.1-.42.03-.52-.15s-.03-.42.15-.52.42-.03.52.15.03.42-.15.52Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-65",
    d: "m208.79,112.86c-.34.09-.53.44-.44.78s.44.53.78.44.53-.44.44-.78-.44-.53-.78-.44Zm.28.98c-.2.06-.42-.06-.47-.27s.06-.42.27-.47.42.06.47.27-.06.42-.27.47Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-65",
    d: "m206.63,120.03l-1.98,1.08-3.77-1.1s-.05,0-.08,0l-.5.28c-.05.03-.07.09-.04.14s.09.07.14.04l.47-.26,3.77,1.1s.05,0,.08,0l2.02-1.11c.05-.03.07-.09.04-.14s-.09-.07-.14-.04Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-65",
    d: "m199.6,120.11c-.31.17-.42.55-.25.86s.55.42.86.25.42-.55.25-.86-.55-.42-.86-.25Zm.49.89c-.19.1-.42.03-.52-.15s-.03-.42.15-.52.42-.03.52.15.03.42-.15.52Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-65",
    d: "m201.78,118.34c-.31.17-.42.55-.25.86s.55.42.86.25.42-.55.25-.86-.55-.42-.86-.25Zm.49.89c-.19.1-.42.03-.52-.15s-.03-.42.15-.52.42-.03.52.15.03.42-.15.52Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-65",
    d: "m206.4,119.1l-1.04-.22-2.22-.61s-.06,0-.08.01l-.51.28c-.05.03-.07.1-.05.15s.1.07.15.04l.47-.26,2.18.6s0,0,0,0l.99.21.31.56c.03.05.1.07.15.04s.07-.1.05-.15l-.33-.61s-.04-.05-.07-.05Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-65",
    d: "m209.16,122.19l-6.28,3.44-.87-.03c-.08,0-.18.05-.22.12-.04.07,0,.13.07.13l.93.03s.08-.01.12-.03l6.34-3.47c.08-.05.13-.12.1-.17s-.12-.05-.2,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-65",
    d: "m207.19,121.15l-1.45.79-4.32-.5s-.07,0-.11.02l-1.16.64c-.07.04-.11.11-.08.17s.11.06.18.02l1.11-.61,4.32.5s.07,0,.11-.02l1.5-.82c.07-.04.11-.11.08-.17s-.11-.06-.18-.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-65",
    d: "m215.03,116.15c.17.31.55.42.86.25s.42-.55.25-.86-.55-.42-.86-.25-.42.55-.25.86Zm.22-.12c-.1-.19-.03-.42.15-.52s.42-.03.52.15.03.42-.15.52-.42.03-.52-.15Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-65",
    d: "m215.9,117.74c.17.31.55.42.86.25s.42-.55.25-.86-.55-.42-.86-.25-.42.55-.25.86Zm.22-.12c-.1-.19-.03-.42.15-.52s.42-.03.52.15.03.42-.15.52-.42.03-.52-.15Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-65",
    d: "m214.16,114.56c.17.31.55.42.86.25s.42-.55.25-.86-.55-.42-.86-.25-.42.55-.25.86Zm.22-.12c-.1-.19-.03-.42.15-.52s.42-.03.52.15.03.42-.15.52-.42.03-.52-.15Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-65",
    d: "m209.67,120.68l5.01-2.74.56-1.63c.02-.06.08-.09.14-.08.06.01.09.07.07.13l-.58,1.68s-.03.05-.06.07l-5.05,2.77c-.06.03-.12.01-.15-.04s0-.12.05-.15Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-65",
    d: "m209.26,122.07l6.28-3.44.45-.75c.04-.07.14-.12.22-.12.08,0,.11.06.07.13l-.48.8s-.05.06-.09.09l-6.34,3.47c-.08.05-.18.04-.2,0s.02-.13.1-.17Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-65",
    d: "m208.81,118.78l1.98-1.08,1.1-3.77s.03-.05.05-.06l.5-.28c.05-.03.11,0,.14.04s0,.11-.04.14l-.47.26-1.1,3.77s-.03.05-.05.06l-2.02,1.11c-.05.03-.11,0-.14-.04s0-.11.04-.14Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-65",
    d: "m212.4,113.76c.17.31.55.42.86.25s.42-.55.25-.86-.55-.42-.86-.25-.42.55-.25.86Zm.22-.12c-.1-.19-.03-.42.15-.52s.42-.03.52.15.03.42-.15.52-.42.03-.52-.15Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-65",
    d: "m209.45,119.85l1.45-.79,1.9-3.91s.04-.06.08-.08l1.16-.64c.07-.04.16-.03.18.02s0,.13-.08.17l-1.11.61-1.9,3.91s-.04.06-.08.08l-1.5.82c-.07.04-.16.03-.18-.02s0-.13.08-.17Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-65",
    d: "m209.11,113.93c-.05.02-.09.07-.07.13l.44,1.58-1.09,1.95s-.02.05,0,.08l.49,1.72c.02.05.07.09.13.07s.09-.07.07-.13l-.47-1.68,1.09-1.95s.02-.05,0-.08l-.46-1.62c-.02-.05-.07-.09-.13-.07Z"
  }), /*#__PURE__*/React.createElement("text", {
    className: "cls-11",
    transform: "translate(207.38 129.32) rotate(-.44)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "KI")))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 503.49,
    y1: 227.74,
    x2: 429.9,
    y2: 227.74
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 503.49,
    y1: 235.52,
    x2: 429.9,
    y2: 235.52
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 503.49,
    y1: 243.3,
    x2: 429.9,
    y2: 243.3
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 503.49,
    y1: 251.07,
    x2: 429.9,
    y2: 251.07
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "m380.05,237.56c0,.11.07.2.18.23.02,0,.04,0,.06,0,.09,0,.17-.05.21-.12h0c.71-1.29,2.06-2.09,3.52-2.09h.45v1.34c0,.1.06.18.14.22.09.04.19.02.26-.05l2.68-2.61s.07-.11.07-.17-.03-.13-.07-.17l-2.68-2.61c-.07-.07-.17-.09-.26-.05-.09.04-.14.12-.14.22v1.34c-2.45.04-4.42,2.04-4.42,4.5Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "m418.88,224.27c6.14,6.25,6.05,16.3-.2,22.44-6.25,6.14-16.3,6.05-22.45-.2-6.14-6.25-6.05-16.3.2-22.44,6.25-6.14,16.3-6.05,22.45.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "m418.72,223.25c6.05,6.16,5.97,16.07-.2,22.12-6.16,6.05-16.07,5.96-22.12-.2-6.05-6.16-5.97-16.07.2-22.12,6.16-6.05,16.07-5.96,22.12.2Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-29"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-40",
    d: "m416.2,233.08c-.45-1.03-.31-1.95-.27-2.73.17-4.02-2.35-7.35-7.99-7.64-3.84-.2-7.81.51-10.9,4.37-3.73,4.66-2.08,11.61,2.37,15.93,1.68,1.64,1.47,3.06,1.47,3.06l-4.09,10.98,16.93-.22-2.58-5.3,1.29-6.08s3.74.4,4.53-1.09c.21-.41-.02-5.95-.02-5.95l1.36-.55c.35-.14.46-.55.23-.84-.76-.95-1.86-2.87-2.33-3.93Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-32",
    d: "m407.95,223.5c-.43-.02-.84-.03-1.23-.03-3.94.03-6.81,1.32-9.04,4.07-.83,1.02-1.39,2.19-1.67,3.48-.27,1.23-.29,2.54-.05,3.9.22,1.23.87,3.19,2.47,4.71,2.79,2.66,6.06-4.35,9.04-4.93,5.82-1.14,6.69-2.8,6.97-3.55.13-.35,1.05-3.12-.86-5.51-1.11-1.39-3.19-2.03-5.64-2.15Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-65",
    d: "m397.52,235.29c-.31.17-.42.55-.25.86s.55.42.86.25.42-.55.25-.86-.55-.42-.86-.25Zm.49.89c-.19.1-.42.03-.52-.15s-.03-.42.15-.52.42-.03.52.15.03.42-.15.52Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-65",
    d: "m398.39,236.88c-.31.17-.42.55-.25.86s.55.42.86.25.42-.55.25-.86-.55-.42-.86-.25Zm.49.89c-.19.1-.42.03-.52-.15s-.03-.42.15-.52.42-.03.52.15.03.42-.15.52Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-65",
    d: "m396.65,233.71c-.31.17-.42.55-.25.86s.55.42.86.25.42-.55.25-.86-.55-.42-.86-.25Zm.49.89c-.19.1-.42.03-.52-.15s-.03-.42.15-.52.42-.03.52.15.03.42-.15.52Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-65",
    d: "m405.08,233.48l-5.01,2.74-1.68-.4c-.06-.01-.12.02-.14.08-.02.06.01.11.07.13l1.72.42s.06,0,.09-.01l5.05-2.77c.06-.03.08-.1.05-.15s-.09-.07-.15-.04Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-65",
    d: "m401.19,227.83l-.53-.96c-.03-.05-.09-.07-.14-.04s-.07.09-.04.14l.55,1s.04.04.06.05l2.05.57,1.67,3.04c.03.05.09.07.14.04s.07-.09.04-.14l-1.69-3.08s-.04-.04-.06-.05l-2.05-.57Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-65",
    d: "m399.98,225.9c-.31.17-.42.55-.25.86s.55.42.86.25.42-.55.25-.86-.55-.42-.86-.25Zm.49.89c-.19.1-.42.03-.52-.15s-.03-.42.15-.52.42-.03.52.15.03.42-.15.52Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-65",
    d: "m403.74,225.05c-.05.03-.07.09-.04.14l.96,1.76-.43,1.48s0,.05,0,.08l1.23,2.24c.03.05.09.07.14.04s.07-.09.04-.14l-1.21-2.2.43-1.48s0-.05,0-.08l-.98-1.8c-.03-.05-.09-.07-.14-.04Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-65",
    d: "m403.24,224.19c-.31.17-.42.55-.25.86s.55.42.86.25.42-.55.25-.86-.55-.42-.86-.25Zm.49.89c-.19.1-.42.03-.52-.15s-.03-.42.15-.52.42-.03.52.15.03.42-.15.52Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-65",
    d: "m406.1,224.55c-.34.09-.53.44-.44.78s.44.53.78.44.53-.44.44-.78-.44-.53-.78-.44Zm.28.98c-.2.06-.42-.06-.47-.27s.06-.42.27-.47.42.06.47.27-.06.42-.27.47Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-65",
    d: "m403.95,231.72l-1.98,1.08-3.77-1.1s-.05,0-.08,0l-.5.28c-.05.03-.07.09-.04.14s.09.07.14.04l.47-.26,3.77,1.1s.05,0,.08,0l2.02-1.11c.05-.03.07-.09.04-.14s-.09-.07-.14-.04Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-65",
    d: "m396.92,231.79c-.31.17-.42.55-.25.86s.55.42.86.25.42-.55.25-.86-.55-.42-.86-.25Zm.49.89c-.19.1-.42.03-.52-.15s-.03-.42.15-.52.42-.03.52.15.03.42-.15.52Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-65",
    d: "m399.1,230.02c-.31.17-.42.55-.25.86s.55.42.86.25.42-.55.25-.86-.55-.42-.86-.25Zm.49.89c-.19.1-.42.03-.52-.15s-.03-.42.15-.52.42-.03.52.15.03.42-.15.52Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-65",
    d: "m403.71,230.79l-1.04-.22-2.22-.61s-.06,0-.08.01l-.51.28c-.05.03-.07.1-.05.15s.1.07.15.04l.47-.26,2.18.6s0,0,0,0l.99.21.31.56c.03.05.1.07.15.04s.07-.1.05-.15l-.33-.61s-.04-.05-.07-.05Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-65",
    d: "m406.47,233.88l-6.28,3.44-.87-.03c-.08,0-.18.05-.22.12-.04.07,0,.13.07.13l.93.03s.08-.01.12-.03l6.34-3.47c.08-.05.13-.12.1-.17s-.12-.05-.2,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-65",
    d: "m404.5,232.84l-1.45.79-4.32-.5s-.07,0-.11.02l-1.16.64c-.07.04-.11.11-.08.17s.11.06.18.02l1.11-.61,4.32.5s.07,0,.11-.02l1.5-.82c.07-.04.11-.11.08-.17s-.11-.06-.18-.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-65",
    d: "m412.34,227.84c.17.31.55.42.86.25s.42-.55.25-.86-.55-.42-.86-.25-.42.55-.25.86Zm.22-.12c-.1-.19-.03-.42.15-.52s.42-.03.52.15.03.42-.15.52-.42.03-.52-.15Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-65",
    d: "m413.21,229.42c.17.31.55.42.86.25s.42-.55.25-.86-.55-.42-.86-.25-.42.55-.25.86Zm.22-.12c-.1-.19-.03-.42.15-.52s.42-.03.52.15.03.42-.15.52-.42.03-.52-.15Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-65",
    d: "m411.47,226.25c.17.31.55.42.86.25s.42-.55.25-.86-.55-.42-.86-.25-.42.55-.25.86Zm.22-.12c-.1-.19-.03-.42.15-.52s.42-.03.52.15.03.42-.15.52-.42.03-.52-.15Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-65",
    d: "m406.99,232.37l5.01-2.74.56-1.63c.02-.06.08-.09.14-.08.06.01.09.07.07.13l-.58,1.68s-.03.05-.06.07l-5.05,2.77c-.06.03-.12.01-.15-.04s0-.12.05-.15Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-65",
    d: "m406.58,233.76l6.28-3.44.45-.75c.04-.07.14-.12.22-.12.08,0,.11.06.07.13l-.48.8s-.05.06-.09.09l-6.34,3.47c-.08.05-.18.04-.2,0s.02-.13.1-.17Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-65",
    d: "m406.12,230.47l1.98-1.08,1.1-3.77s.03-.05.05-.06l.5-.28c.05-.03.11,0,.14.04s0,.11-.04.14l-.47.26-1.1,3.77s-.03.05-.05.06l-2.02,1.11c-.05.03-.11,0-.14-.04s0-.11.04-.14Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-65",
    d: "m409.72,225.44c.17.31.55.42.86.25s.42-.55.25-.86-.55-.42-.86-.25-.42.55-.25.86Zm.22-.12c-.1-.19-.03-.42.15-.52s.42-.03.52.15.03.42-.15.52-.42.03-.52-.15Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-65",
    d: "m406.76,231.54l1.45-.79,1.9-3.91s.04-.06.08-.08l1.16-.64c.07-.04.16-.03.18.02s0,.13-.08.17l-1.11.61-1.9,3.91s-.04.06-.08.08l-1.5.82c-.07.04-.16.03-.18-.02s0-.13.08-.17Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-65",
    d: "m406.42,225.62c-.05.02-.09.07-.07.13l.44,1.58-1.09,1.95s-.02.05,0,.08l.49,1.72c.02.05.07.09.13.07s.09-.07.07-.13l-.47-1.68,1.09-1.95s.02-.05,0-.08l-.46-1.62c-.02-.05-.07-.09-.13-.07Z"
  }), /*#__PURE__*/React.createElement("text", {
    className: "cls-11",
    transform: "translate(404.69 241.01) rotate(-.44)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "KI"))))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-48",
    d: "m126.12,345.68c-32.23-.04-69.8-.27-62.47-4.11,7.33-3.84,35.65-.67,67.4-1.37,15.3-.34,10.83-2,31.56-.87,32.44,1.77,23.61,4.08,9.38,4.7-26.16,1.13-27.71,1.6-29.82,1.64-3.79.07-3.5.01-16.05,0Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-93",
    x: 103.27,
    y: 147.4,
    width: 6.91,
    height: 16.49,
    transform: "translate(-7.32 5.28) rotate(-2.74)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-93",
    d: "m114.29,145.71c1.27,3.86-.42,7.01-3.71,8.09-3.29,1.09-6.93-.3-8.2-4.16-.18-.55-2.8-7.47-2.86-8.01l1.8-2.5,9.21-2.35,1.6.69c.27.48,1.98,7.7,2.16,8.24Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-45",
    d: "m105.9,133.96c.89-.44,2.48-1.91,3.48-1.92,1.63-.01,2.56,1.36,3.01,2.17.33.6.66,2.04.46,2.69-.08.24-.7.72-.7.72,0,0-6.91.81-8.74,2.11-.29.21-.7.86-.78,1.21-.21.93.47,3.79.47,3.79l-.5.17-1.37-1.42-.29.23.06,1.45.9.93.46,3.54-1.12-1.45-1.18-2.42s-1.78-2.46-2.14-3.4c-.2-.5-.57-2.08-.3-2.71.14-.34,1.16-.93,1.16-.93,0,0-.12-1.23.05-1.58.41-.86,2.15-1.88,3.11-2.17,1.34-.4,2.11-.51,2.11-.51,0,0,1.44-.29,1.88-.5Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-73",
    d: "m110.23,156.52s9.57-1.49,11.69-1.07c4.98.98,4.74,5.19,5.2,9.34,0,0,2.07,18.37,2.91,24.61.74,5.48,3.57,25.21,3.57,25.21l.3,2.89-.06,1.64.06,1.59-35.52.06-.09-1.71-.39-2.87-.21-1.38s-.82-10.81-1.48-15.41c-.63-4.43-2.42-11.99-3.5-16.11-.67-2.55-2.76-10.62-2.76-10.62-1.24-3.16-2.25-7.89,1.72-10.25,2.11-1.26,11.69-4.74,11.69-4.74,0,0,2.28,4.84,5.32,4.25,2.02-.39,1.6-4.28,1.55-5.24,0-.12,0-.19,0-.19Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-91",
    d: "m118.31,341.12h-.19s-.04.95-.04.95h-4.56s.12-1.26.12-1.26h.15s0-.02,0-.02l1.1-5.1,4.63.47.1.61,1.19,1.6,6.91,1.98s.54.24.53.54l-.02.55v.33s-.1.15-.66.31h-7.92s-.48-.64-.48-.64l-.47-.29-.4-.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-91",
    d: "m80.95,337.64l-.18-.07-.4.86-4.21-1.74.6-1.12.14.05h0s2.24-4.18,2.24-4.18l4.37,1.8-.14.6.95,2.21,5.63,4.46s.41.43.29.7l-.23.5-.14.3s-.13.1-.72.04l-7.32-3.02-.2-.77-.32-.45-.36-.17Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-79",
    points: "88.58 279.98 77.71 332.14 84.91 334.29 101.25 282.13 114.34 232.6 115.27 232.45 115.7 282.39 113.52 336.05 121.1 336.93 128.45 281.85 133.6 231.96 133.97 225.52 133.97 219.21 98.09 219.21 98.07 219.89 96.46 221.45 97.02 226.93 88.58 279.98"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-93",
    points: "155.02 102.38 153.2 99.52 153.05 99.14 152.24 98.46 150.75 101.31 149.46 103.83 149.2 103.9 149.22 102.44 148.85 101.42 148.07 100.6 147.85 100.67 147.83 102.59 147.35 105.82 147.83 108.44 146.22 114.9 150.72 116.18 152.04 109.18 154.07 105.8 155.02 102.38"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-73",
    d: "m139.88,135.95s2.51-2.58,5.7-.81c1.84,1.03,2.53,4.47.84,6.93,0,0-14.27,18.56-19.53,21.91-2.29,1.45-5.73-1.07-6.41-2.13-.64-1-2.42-3.89.08-6.46,6.88-7.08,13.61-12.64,19.33-19.43"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-73",
    d: "m152.31,112.12s-2.32,20.34-5.24,28.56c-.9,2.55-4.15,3.14-5.63,2.38-2.4-1.24-2.72-3.88-2-6.18,2.5-7.98,7.48-27.1,7.48-27.1l5.39,2.34Z"
  }))), /*#__PURE__*/React.createElement("path", {
    className: "cls-86",
    d: "m152.31,113.61c-.02.2-2.04,19.02-4.94,27.19,0,.02-.02.03-.02.05-.17.5-.38.98-.68,1.41-.58.77-14.47,18.61-19.72,21.95-.51.32-.9.44-1.46.6-1.66.47-4.66-1.8-5.3-2.79-1.73-2.69-2.03-4.76-.21-6.62,2.66-2.73,5.63-5.48,8.18-7.91,4-3.81,7.77-7.41,11.22-11.46,2.54-8.27,7.17-25.33,7.22-25.51l5.71,3.09Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-86",
    d: "m121.98,155.14c4.65.92,4.99,4.64,5.32,8.23.04.46.08.92.13,1.39.02.18,2.08,18.43,2.91,24.6.73,5.41,6.39,32.79,6.33,32.92-1.07,2.63-7.52-.04-8.8-1.89-4.2-6.05-6.07-34.66-9.38-45.14-4.04-12.8-8.27-18.73-8.27-18.73l.25-.08s9.8-1.65,11.5-1.31Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-86",
    d: "m91.51,162.16c1.58-.94,7.05-2.88,9.92-3.94,1.4-.4,1.86-.49,1.86-.49,0,0,5.46,16.18,9.62,32.44,3.34,13.06,3.31,28.56.78,31.95-2.28,3.06-15.81,3.58-18.02,2.93-1.63-.48-1.76-.87-1.9-1.24-.09-.24.18-1.57.48-3.9.76-6.01,1.07-16.89.61-20.16-.63-4.42-1.39-12.3-2.45-16.34-.66-2.54-2.76-10.59-2.75-10.59-1.99-5.06-1.35-8.74,1.86-10.65Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-93",
    points: "147.32 198.78 151.38 197.58 151.87 196.98 151.6 196.41 147.68 196.84 145.53 196.2 145.41 195.95 146.39 195.97 147.53 195.96 148.31 195.48 148.29 195.36 145.68 194.73 143.31 194.48 140.83 195.43 133.21 194.91 132.78 199.05 140.69 199.26 143.92 199.74 147.32 198.78"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "m137.63,200.06s-25.59,1.19-29.34.74c-3.12-.38-4.38-4-3.57-5.97,1.03-2.5,4-2.62,6.4-2.37,4.18.45,27.51,2.46,27.51,2.46l-1.01,5.13Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "m113.14,194.93c-.67-2.08-12.03-24.26-14.26-27.86-1.89-3.05-5.73-5.63-7.73-4.23-2.57,1.79-2.6,4.87-1.92,7.83,1.3,5.62,14.18,25.64,15.9,28.1,1.7,2.45,4.19,2.58,6.75.9,1.09-.71,1.92-2.7,1.27-4.74Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-53",
    d: "m136.47,200.36c-.87.04-17.05.87-24.89.87-1.54,0-2.71-.03-3.33-.1-1.4-.17-2.59-.97-3.35-2.27-.77-1.31-.96-2.98-.48-4.14.88-2.12,3.08-2.95,6.73-2.56,4.12.44,26.1,2.42,26.34,2.44l-1.02,5.77Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-53",
    d: "m90.96,162.57c.61-.43,1.38-.55,2.29-.36,2.02.42,4.44,2.34,5.9,4.69,2.27,3.66,13.63,25.86,14.3,27.93.7,2.17-.16,4.3-1.4,5.11-1.2.79-2.36,1.17-3.43,1.17-1.46,0-2.76-.73-3.76-2.16-1.14-1.64-14.58-22.28-15.95-28.21-.9-3.91-.23-6.58,2.05-8.17Z"
  }))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    className: "cls-51"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-31",
    d: "m553.52,343.11c-19.81-.04-56.32.79-51.81-3.43,4.51-4.22,28.29-.09,47.78-1.5,19.49-1.41,37.14-3.04,57.07-.95,19.94,2.09,14.52,4.49,5.77,5.17-16.08,1.25-18.93,1.79-28.26,1.1-27.29-2-22.84-.37-30.56-.38Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-72",
    points: "510.08 135.55 510.59 131.39 513.96 132.68 516.04 133.2 516.49 133.06 515.56 132.46 514.51 132.01 514.28 130.97 515.94 131.38 518.42 132.65 519.99 134.24 521.04 135.67 529.73 141.28 526.21 145.44 518.42 138.92 514.02 137.74 510.08 135.55"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-72",
    points: "599.13 222.19 599.8 226.35 599.03 227.88 598.26 230.1 598.88 235.05 600.05 235.25 600.15 232.28 600.6 232.38 600.61 237.93 604.08 236.05 605.29 231.17 605.02 228.99 603.8 225.51 603.53 221.6 599.13 222.19"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-86",
    d: "m600.39,205.73l-.38.05c-2.36.21-3.91-1.23-4.84-4.26-2.15-6.99-6.28-20.29-7.88-28.24-.83-4.13,1.19-5.44,3.28-6.36l.4-.16c2.9-.86,5.98,2.3,7.02,7.26,1.77,8.51,5.74,26.72,5.74,26.72.31,2.56-.98,4.76-3.34,4.98Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-86",
    d: "m604.26,223.97l-5.37.03s-2.92-14.48-2.97-21.02c-.03-3.33.46-5.25,2.81-5.61h0c2.34-.36,4.95.68,5.14,4.65.28,6.04.4,21.94.4,21.94Z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-86",
    d: "m536.6,151.13l.22-.31c1.47-1.87,3.58-1.99,6.42-.59,6.56,3.24,17.09,7.49,23.96,11.78,3.58,2.23,2.13,4.92,1.36,7.07l-.16.4c-1.37,2.7-4.32,4.11-6.5,2.71-7.32-4.69-23.98-15.22-23.98-15.22-2.07-1.54-2.79-3.99-1.32-5.85Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-86",
    d: "m520.69,141.41l3.67-3.92s12.53,7.82,17.31,12.28c2.44,2.27,3.5,3.94,2.15,5.89h0c-1.35,1.95-3.9,3.13-6.91.54-4.58-3.95-16.22-14.78-16.22-14.78Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-72",
    x: 575.03,
    y: 160.24,
    width: 10.51,
    height: 6.57,
    transform: "translate(346.25 719.14) rotate(-82.9)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-72",
    x: 569.66,
    y: 164.29,
    width: 18.95,
    height: 10.79,
    transform: "translate(25.43 -70.32) rotate(7.1)"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-72",
    d: "m573.86,149.61c-1.9,4.28-.47,9.07,3.18,10.69,3.65,1.62,8.15-.55,10.05-4.83.27-.61,4.05-8.26,4.18-8.87l-14.01-6.2c-.36.52-3.14,8.61-3.41,9.22Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-34",
    d: "m592.02,147.3c1.72-5.92-3.16-8.45-3.16-8.45l-12.24-5.01c-2.53,3.93.39,7.3.39,7.3l10.39,4.25-.87,4.91.55.26,1.92-2.06.45.11-2.63,7.39,1.45-1.54,2.3-3.73,1.42-3.42Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-35",
    d: "m573.87,149.12c.47.57,3.63,3.04,4.32,3.28,3.79,1.33,5.88,1.46,5.88,1.46l2.48-3.55.55.26-.98,4.5-.46,2.92s-.96,1.17-2.11,1.92c-1.39.9-2.84,1.37-4.29,1.15-.77-.12-2.33-.59-2.97-.96-.97-.55-1.77-1.53-2.2-2.13-2.39-3.27-1.16-6.8-.22-8.84Z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-91",
    d: "m561.59,340.24h.19l.04.96h4.6l-.13-1.27h-.15s0-.02,0-.02v-4.68h-4.79l-.1.62-2.21,1.62-6.98,2s-.55.24-.54.54l.02.55v.33s.1.15.67.31h8.01l.48-.64.47-.3.41-.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-91",
    d: "m583.43,340.24h.19l.04.96h4.6l-.12-1.27h-.15s0-.02,0-.02v-4.68h-4.79l-.1.62-2.21,1.62-6.98,2s-.55.24-.54.54l.02.55v.33s.1.15.67.31h8.01l.48-.64.47-.3.41-.02Z"
  })), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-89",
    points: "588.12 222.62 555.25 222.62 555.25 235.35 555.97 240.51 556.46 289.91 559.2 336.03 567.09 336.03 567.06 288.94 570.62 248.89 570.86 247.1 575.69 289.27 581.57 335.72 589.09 335.85 587.46 288.26 586.6 248.33 587.98 236.26 588.12 222.62"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-86",
    d: "m574.68,163.47l.82.1,1.72,3.03c1.06,1.86,3.61,2.16,5.07.6l2.32-2.49s6.69,1.25,8.74,2.17c3.86,1.74,3.93,6.56,3.58,9.37l-3.4,12.86-2.31,15.66-1.35,18.21-1.02,3.54-33.52-1.51-1.27-3.24,2.95-19.35.83-6.7,1.19-25.83c.49-3.92,2.83-7.8,7.75-7.96l7.89,1.55Z"
  }))), /*#__PURE__*/React.createElement("path", {
    className: "cls-72",
    d: "m574.71,152.22s2.48,3.06,5.8,2.87c0,0-5.48,3.38-5.8-2.87Z"
  }))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAiReviews);
export default __webpack_public_path__ + "static/media/ai_reviews.54775e5cf013fc0d1a61145b83577e46.svg";
export { ForwardRef as ReactComponent };